webpackJsonp([1],Array(81).concat([
/* 81 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjIxNjczLjg4NSA1NzE0LjU4NyAxOC41MjkgMTAuNjgiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxMDI5LjU2MyA1MzAxLjAzNykiPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzQxNDA0MiIgc3Ryb2tlLXdpZHRoPSIycHgiIGQ9Ik0xMjkxOC43LDc4ODZsOC41NTgsOC41NTksOC41NTgtOC41NTkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjI3My42NzIgLTc0NzEuNzQzKSIvPjwvZz48L3N2Zz4K"

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(765),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(673)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(791),
  /* scopeId */
  "data-v-73850404",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMS4xMiAyMS4xMiI+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjN2M3YzdkIiBkPSJNMTEuNDYuNWwyLjI4MywxMy4zMjdMLjUsMTEuNDZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEwKSByb3RhdGUoLTQ1KSIvPjwvc3ZnPg=="

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(687)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(804),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(787),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(648)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(762),
  /* scopeId */
  "data-v-0b4d7d07",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(782),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(663)
__webpack_require__(662)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(778),
  /* scopeId */
  "data-v-506c16da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(686)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(803),
  /* scopeId */
  "data-v-effe2412",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(653)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(768),
  /* scopeId */
  "data-v-25203ef0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(679)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(797),
  /* scopeId */
  "data-v-944066d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(657)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(773),
  /* scopeId */
  "data-v-450f8930",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(640)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(754),
  /* scopeId */
  "data-v-0369270a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(672)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(789),
  /* scopeId */
  "data-v-684d8044",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_waypoint__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_waypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_waypoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_moment__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_axios__ = __webpack_require__(346);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_waypoint___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__plugins_moment__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__plugins_axios__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: __webpack_require__.i({"NODE_ENV":"production"}).API_ROOT || '/wp-json/lst/v1',
  responseType: 'json'
});

var commentInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: __webpack_require__.i({"NODE_ENV":"production"}).API_COMMENT_ROOT || '/wp-json/wp/v2',
  responseType: 'json'
});

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Object.defineProperty(Vue.prototype, '$axios', { value: instance });
    Object.defineProperty(Vue.prototype, '$comments', { value: commentInstance });
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Object.defineProperty(Vue.prototype, '$moment', { value: __WEBPACK_IMPORTED_MODULE_0_moment___default.a });
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Books__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Books___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Books__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Participate__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Participate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Participate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Resources__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Resources___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Resources__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Post__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Post__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Preview__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Episodes__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Episodes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Episodes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Extras__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Extras___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Extras__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Search__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Tag__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_NotFound__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_NotFound__);

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Home___default.a
}, {
  path: '/about',
  name: 'About',
  component: __WEBPACK_IMPORTED_MODULE_4__components_About___default.a
}, {
  path: '/books',
  name: 'Books',
  component: __WEBPACK_IMPORTED_MODULE_5__components_Books___default.a
}, {
  path: '/participate',
  name: 'Participate',
  component: __WEBPACK_IMPORTED_MODULE_6__components_Participate___default.a
}, {
  path: '/resources',
  name: 'Resources',
  component: __WEBPACK_IMPORTED_MODULE_7__components_Resources___default.a
}, {
  name: 'Episodes',
  path: '/episodes',
  component: __WEBPACK_IMPORTED_MODULE_10__components_Episodes___default.a
}, {
  name: 'Extras',
  path: '/extras',
  component: __WEBPACK_IMPORTED_MODULE_11__components_Extras___default.a
}, {
  name: 'Search',
  path: '/search',
  component: __WEBPACK_IMPORTED_MODULE_12__components_Search___default.a
}, {
  name: 'Preview',
  path: '/preview',
  component: __WEBPACK_IMPORTED_MODULE_9__components_Preview___default.a
}, {
  name: 'Post',
  path: '/:slug',
  component: __WEBPACK_IMPORTED_MODULE_8__components_Post___default.a
}, {
  name: 'Category',
  path: '/category/:topic',
  component: __WEBPACK_IMPORTED_MODULE_10__components_Episodes___default.a
}, {
  name: 'Tag',
  path: '/tag/:tag',
  component: __WEBPACK_IMPORTED_MODULE_13__components_Tag___default.a
}, {
  name: 'NotFound',
  path: '/404',
  component: __WEBPACK_IMPORTED_MODULE_14__components_NotFound___default.a,
  alias: '*'
}];

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  } else if (to.hash) {
    return {
      selector: to.hash
    };
  } else {
    return { x: 0, y: 0 };
  }
};

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes,
  scrollBehavior: scrollBehavior
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_analytics___default.a, {
  id: 'UA-21941912-1',
  router: router
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: {
    playingEpisode: null,
    currentPost: null,
    playing: false,
    loading: false,
    dirty: false,
    episodes: {
      posts: []
    },
    extras: [],
    siteData: {},
    searchQuery: '',
    siteInfo: null
  },
  mutations: {
    SET_EXTRAS: function SET_EXTRAS(state, payload) {
      state.extras = payload;
    },
    ADD_TO_EXTRAS: function ADD_TO_EXTRAS(state, payload) {
      state.extras.posts = state.extras.posts.concat(payload);
    },
    SET_EPISODES: function SET_EPISODES(state, payload) {
      state.episodes = payload;
    },
    ADD_TO_EPISODES: function ADD_TO_EPISODES(state, payload) {
      state.episodes.posts = state.episodes.posts.concat(payload);
    },
    SET_SEARCH_QUERY: function SET_SEARCH_QUERY(state, payload) {
      state.searchQuery = payload;
    },
    SET_PLAYING_EPISODE: function SET_PLAYING_EPISODE(state, payload) {
      state.dirty = true;
      state.playingEpisode = payload;
    },
    SET_CURRENT_POST: function SET_CURRENT_POST(state, payload) {
      state.currentPost = payload;
    },
    SET_PLAYER_PLAYING: function SET_PLAYER_PLAYING(state, payload) {
      state.playing = payload;
    },
    SET_PLAYER_LOADING: function SET_PLAYER_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_SITE_INFO: function SET_SITE_INFO(state, payload) {
      state.siteInfo = payload;
    }
  },
  actions: {
    setEpisodes: function setEpisodes(_ref, payload) {
      var commit = _ref.commit;

      commit('SET_EPISODES', payload);
    },
    addToEpisodes: function addToEpisodes(_ref2, payload) {
      var commit = _ref2.commit;

      commit('ADD_TO_EPISODES', payload);
    },
    setExtras: function setExtras(_ref3, payload) {
      var commit = _ref3.commit;

      commit('SET_EXTRAS', payload);
    },
    addToExtras: function addToExtras(_ref4, payload) {
      var commit = _ref4.commit;

      commit('ADD_TO_EXTRAS', payload);
    },
    setPlayingEpisode: function setPlayingEpisode(_ref5, payload) {
      var commit = _ref5.commit;

      commit('SET_PLAYING_EPISODE', payload);
    },
    setPlayerPlaying: function setPlayerPlaying(_ref6, payload) {
      var commit = _ref6.commit;

      commit('SET_PLAYER_PLAYING', payload);
    },
    setPlayerLoading: function setPlayerLoading(_ref7, payload) {
      var commit = _ref7.commit;

      commit('SET_PLAYER_LOADING', payload);
    },
    setCurrentPost: function setCurrentPost(_ref8, payload) {
      var commit = _ref8.commit;

      commit('SET_CURRENT_POST', payload);
    },
    setSearchQuery: function setSearchQuery(_ref9, payload) {
      var commit = _ref9.commit;

      commit('SET_SEARCH_QUERY', payload);
    },
    setSiteInfo: function setSiteInfo(_ref10, payload) {
      var commit = _ref10.commit;

      commit('SET_SITE_INFO', payload);
    }
  },
  getters: {
    episodes: function episodes(state) {
      if (state.episodes) return state.episodes.posts;
    },
    totalEpisodePages: function totalEpisodePages(state) {
      if (state.episodes) return state.episodes.pages;
    },
    extras: function extras(state) {
      if (state.extras) return state.extras.posts;
    },
    totalExtraPages: function totalExtraPages(state) {
      if (state.extras) return state.extras.pages;
    },
    featuredEpisode: function featuredEpisode(state, getters) {
      if (getters.episodes) return getters.episodes[0];
    },
    latestEpisodes: function latestEpisodes(state, getters) {
      if (getters.episodes) return getters.episodes.slice(1, 4);
    },
    latestExtras: function latestExtras(state, getters) {
      if (getters.extras) return getters.extras.slice(0, 3);
    },
    latestEverything: function latestEverything(state, getters) {
      if (getters.episodes) {
        var episodes = getters.episodes;
        if (getters.extras) {
          return episodes.concat(getters.extras);
        }
      }
    },
    currentPost: function currentPost(state) {
      return state.currentPost;
    },
    playingEpisode: function playingEpisode(state) {
      return state.playingEpisode;
    },
    playerPlaying: function playerPlaying(state) {
      return state.playing;
    },
    playerLoading: function playerLoading(state) {
      return state.loading;
    },
    playerDirty: function playerDirty(state) {
      return state.dirty;
    },
    searchQuery: function searchQuery(state) {
      return state.searchQuery;
    },
    siteInfo: function siteInfo(state) {
      return state.siteInfo;
    },
    socialLinks: function socialLinks(state, getters) {
      if (getters.siteInfo) return getters.siteInfo.social;
    },
    shopItems: function shopItems(state, getters) {
      if (getters.siteInfo && getters.siteInfo.shopItems) return getters.siteInfo.shopItems.slice(0, 3);
    },
    testimonials: function testimonials(state, getters) {
      if (getters.siteInfo && getters.siteInfo.testimonials) return getters.siteInfo.testimonials;
    },
    topBarButtons: function topBarButtons(state, getters) {
      if (getters.siteInfo && getters.siteInfo.topBarButtons) return getters.siteInfo.topBarButtons;
    }
  }
}));

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_TopNav__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_TopNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_TopNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Masthead__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Masthead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Masthead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_SiteFooter__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_SiteFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_SiteFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Player__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_Player__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    TopNav: __WEBPACK_IMPORTED_MODULE_2__components_common_TopNav___default.a,
    Masthead: __WEBPACK_IMPORTED_MODULE_3__components_common_Masthead___default.a,
    SiteFooter: __WEBPACK_IMPORTED_MODULE_4__components_common_SiteFooter___default.a,
    Player: __WEBPACK_IMPORTED_MODULE_5__components_common_Player___default.a
  },
  mounted: function mounted() {
    this.getSiteInfo();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getSiteInfo: function getSiteInfo() {
      var vm = this;

      vm.$axios.get('/site').then(function (response) {
        vm.setSiteInfo(response.data);
      }).catch(function (err) {
        console.log(err.response);
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['setSiteInfo']))
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Hero__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_about_Awards__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_about_Awards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_about_Awards__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_about_Press__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_about_Press___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_about_Press__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_about_Contact__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_about_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_about_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_about_TheTeam__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_about_TheTeam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_about_TheTeam__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_ShopModule__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_ShopModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_ShopModule__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  data: function data() {
    return {
      loading: true,
      page: null
    };
  },
  mounted: function mounted() {
    this.fetchPost();
  },

  methods: {
    fetchPost: function fetchPost() {
      var vm = this;
      vm.$axios.get('/posts', {
        params: {
          slug: 'about'
        }
      }).then(function (response) {
        vm.page = response.data;
        process.nextTick(function () {
          vm.loading = false;
          if (vm.$route.hash) vm.scrollToAnchor();
        });
      }).catch(function (err) {
        vm.loading = false;
        console.log(err);
      });
    },
    scrollToAnchor: function scrollToAnchor() {
      var id = this.$route.hash.replace('#', '');
      process.nextTick(function () {
        document.getElementById(id).scrollIntoView();
      });
    }
  },
  components: {
    Hero: __WEBPACK_IMPORTED_MODULE_0__components_common_Hero___default.a,
    Awards: __WEBPACK_IMPORTED_MODULE_1__components_about_Awards___default.a,
    Press: __WEBPACK_IMPORTED_MODULE_2__components_about_Press___default.a,
    Contact: __WEBPACK_IMPORTED_MODULE_3__components_about_Contact___default.a,
    TheTeam: __WEBPACK_IMPORTED_MODULE_4__components_about_TheTeam___default.a,
    ShopModule: __WEBPACK_IMPORTED_MODULE_5__components_common_ShopModule___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34)))

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'books',
  data: function data() {
    return {
      loading: true,
      page: null
    };
  },
  mounted: function mounted() {
    this.fetchPost();
  },

  methods: {
    fetchPost: function fetchPost() {
      var vm = this;
      vm.$axios.get('/posts', {
        params: {
          slug: 'books'
        }
      }).then(function (response) {
        vm.page = response.data;
        process.nextTick(function () {
          vm.loading = false;
          if (vm.$route.hash) vm.scrollToAnchor();
        });
      }).catch(function (err) {
        vm.loading = false;
        console.log(err);
      });
    },
    scrollToAnchor: function scrollToAnchor() {
      var id = this.$route.hash.replace('#', '');
      process.nextTick(function () {
        document.getElementById(id).scrollIntoView();
      });
    }
  },
  computed: {
    featuredImage: function featuredImage() {
      var vm = this;
      if (vm.page && vm.page.image) {
        var image = vm.page.image.large;
        if (false) {
          image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
        }
        return image;
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34)))

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_episode_Hero__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_episode_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_episode_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Comments__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Comments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Comments__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'episode',
  props: ['episode'],
  data: function data() {
    return {
      transcriptExpanded: false
    };
  },
  mounted: function mounted() {
    window.instgrm.Embeds.process();
    window.twttr.widgets.load();
  },

  computed: {
    episodeTranscript: function episodeTranscript() {
      if (this.transcriptExpanded) {
        return this.episode.transcript;
      } else {
        var splitTranscript = this.episode.transcript.split('</p>');
        return splitTranscript.slice(0, 2).join('</p>') + '</p>';
      }
    },
    topics: function topics() {
      if (this.episode && this.episode.topics) {
        return this.episode.topics.filter(function (topic) {
          return topic.name !== 'PODCAST';
        });
      }
    },
    episodeContent: function episodeContent() {
      var vm = this;
      if (vm.episode && vm.episode.content) {
        var content = vm.episode.content;
        if (false) {
          content = content.split('src="http://longestshortesttime').join('src="http://cdn.longestshortesttime');
        }
        return content;
      }
    }
  },
  components: {
    Hero: __WEBPACK_IMPORTED_MODULE_0__components_episode_Hero___default.a,
    Comments: __WEBPACK_IMPORTED_MODULE_1__components_common_Comments___default.a
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_episodes_EpisodeFilter__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_episodes_EpisodeFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_episodes_EpisodeFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_episodes_Episode__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_episodes_Episode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_episodes_Episode__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'episodes',
  data: function data() {
    return {
      page: 1,
      loading: true,
      topics: null,
      scrolled: false
    };
  },
  mounted: function mounted() {
    if (!this.topic) {
      this.fetchEpisodes();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    nextPage: function nextPage() {
      if (this.page < this.totalEpisodePages) {
        this.page++;
      }
    },
    handleScroll: function handleScroll(direction, going) {
      if (direction.y === 'down' && going === 'in') {
        this.scrolled = true;
      } else if (direction.y === 'up' && going === 'out') {
        this.scrolled = false;
      }
    },
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
      this.scrolled = false;
    },
    fetchEpisodes: function fetchEpisodes() {
      var scrollToTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var vm = this;
      var topicId = vm.thisTopic ? vm.thisTopic.id : '';
      vm.$axios.get('/episodes', {
        params: {
          page: vm.page,
          year: vm.year,
          topic: topicId
        }
      }).then(function (response) {
        vm.loading = false;
        if (!replace) {
          vm.addToEpisodes(response.data.posts);
        } else {
          vm.setEpisodes(response.data);
        }
        if (scrollToTop) {
          vm.scrollToTop();
        }
      }).catch(function (err) {
        vm.loading = false;
        console.log(err.response);
      });
    },
    setPage: function setPage(i) {
      var push = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var vm = this;
      vm.page = parseInt(i);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['setEpisodes', 'addToEpisodes'])),
  components: {
    EpisodeFilter: __WEBPACK_IMPORTED_MODULE_2__components_episodes_EpisodeFilter___default.a,
    Episode: __WEBPACK_IMPORTED_MODULE_3__components_episodes_Episode___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    topic: function topic() {
      return this.$route.params.topic;
    },
    year: function year() {
      return this.$route.query.year;
    },
    thisTopic: function thisTopic() {
      var vm = this;
      if (vm.topics && vm.topic) {
        return vm.topics.find(function (topic) {
          return topic.slug === vm.topic;
        });
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['episodes', 'totalEpisodePages'])),
  watch: {
    year: function year() {
      this.setPage(1);
      this.fetchEpisodes(true, true);
    },
    page: function page() {
      this.fetchEpisodes(false, false);
    },
    thisTopic: function thisTopic() {
      this.setPage(1);
      this.fetchEpisodes(true, true);
    }
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_extra_Hero__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_extra_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_extra_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Comments__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Comments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Comments__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'extra',
  props: ['extra'],
  components: {
    Hero: __WEBPACK_IMPORTED_MODULE_0__components_extra_Hero___default.a,
    Comments: __WEBPACK_IMPORTED_MODULE_1__components_common_Comments___default.a
  },
  mounted: function mounted() {
    window.instgrm.Embeds.process();
    window.twttr.widgets.load();
  },

  computed: {
    extraContent: function extraContent() {
      var vm = this;
      if (vm.extra && vm.extra.content) {
        var content = vm.extra.content;
        if (false) {
          content = content.split('src="http://longestshortesttime').join('src="http://cdn.longestshortesttime');
        }
        return content;
      }
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_extras_ExtraFilter__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_extras_ExtraFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_extras_ExtraFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_extras_Extra__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_extras_Extra___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_extras_Extra__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'extras',
  data: function data() {
    return {
      page: 1,
      loading: true,
      topics: null,
      scrolled: false
    };
  },
  mounted: function mounted() {
    if (!this.topic) {
      this.fetchExtras();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    nextPage: function nextPage() {
      if (this.page < this.totalExtraPages) {
        this.page++;
      }
    },
    handleScroll: function handleScroll(direction, going) {
      if (direction.y === 'down' && going === 'in') {
        this.scrolled = true;
      } else if (direction.y === 'up' && going === 'out') {
        this.scrolled = false;
      }
    },
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
      this.scrolled = false;
    },
    fetchExtras: function fetchExtras() {
      var scrollToTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var vm = this;
      var topicId = vm.thisTopic ? vm.thisTopic.id : '';
      vm.$axios.get('/extras', {
        params: {
          page: vm.page,
          year: vm.year,
          topic: topicId
        }
      }).then(function (response) {
        vm.loading = false;
        if (!replace) {
          vm.addToExtras(response.data.posts);
        } else {
          vm.setExtras(response.data);
        }
        if (scrollToTop) {
          vm.scrollToTop();
        }
      }).catch(function (err) {
        vm.loading = false;
        console.log(err.response);
      });
    },
    setPage: function setPage(i) {
      var push = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var vm = this;
      vm.page = parseInt(i);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['setExtras', 'addToExtras'])),
  components: {
    ExtraFilter: __WEBPACK_IMPORTED_MODULE_2__components_extras_ExtraFilter___default.a,
    Extra: __WEBPACK_IMPORTED_MODULE_3__components_extras_Extra___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    topic: function topic() {
      return this.$route.query.topic;
    },
    year: function year() {
      return this.$route.query.year;
    },
    thisTopic: function thisTopic() {
      var vm = this;
      if (vm.topics && vm.topic) {
        return vm.topics.find(function (topic) {
          return topic.slug === vm.topic;
        });
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['extras', 'totalExtraPages'])),
  watch: {
    year: function year() {
      this.setPage(1);
      this.fetchExtras(true, true);
    },
    page: function page() {
      this.fetchExtras(false, false);
    },
    thisTopic: function thisTopic() {
      this.setPage(1);
      this.fetchExtras(true, true);
    }
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_Hero__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_LatestEpisodes__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_LatestEpisodes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home_LatestEpisodes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_CallToAction__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_CallToAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_home_CallToAction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_LatestExtras__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_LatestExtras___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_home_LatestExtras__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_StartHere__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_StartHere___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_home_StartHere__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_home_Testimonials__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_home_Testimonials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_home_Testimonials__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_ShopModule__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_ShopModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_ShopModule__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    Hero: __WEBPACK_IMPORTED_MODULE_2__components_home_Hero___default.a,
    LatestEpisodes: __WEBPACK_IMPORTED_MODULE_3__components_home_LatestEpisodes___default.a,
    CallToAction: __WEBPACK_IMPORTED_MODULE_4__components_home_CallToAction___default.a,
    LatestExtras: __WEBPACK_IMPORTED_MODULE_5__components_home_LatestExtras___default.a,
    StartHere: __WEBPACK_IMPORTED_MODULE_6__components_home_StartHere___default.a,
    Testimonials: __WEBPACK_IMPORTED_MODULE_7__components_home_Testimonials___default.a,
    ShopModule: __WEBPACK_IMPORTED_MODULE_8__components_common_ShopModule___default.a
  },
  data: function data() {
    return {
      loading: true
    };
  },
  mounted: function mounted() {
    var vm = this;
    if (window.wpApiSettings && window.wpApiSettings.nonce && vm.$route.query.preview === 'true') {
      vm.$router.push({ name: 'Preview', query: { preview_id: vm.$route.query.p } });
    } else {
      vm.fetchEpisodes();
      vm.fetchExtras();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    fetchEpisodes: function fetchEpisodes() {
      var vm = this;

      vm.$axios.get('/episodes').then(function (response) {
        vm.setEpisodes(response.data);
        vm.loading = false;
      }).catch(function (err) {
        console.log(err.response);
        vm.loading = false;
      });
    },
    fetchExtras: function fetchExtras() {
      var vm = this;

      vm.$axios.get('/extras').then(function (response) {
        vm.setExtras(response.data);
        vm.loading = false;
      }).catch(function (err) {
        console.log(err.response);
        vm.loading = false;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['setEpisodes', 'setExtras'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['featuredEpisode', 'latestEpisodes', 'latestExtras']))
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'not-found'
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Hero__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Hero__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page',
  props: ['page'],
  components: {
    Hero: __WEBPACK_IMPORTED_MODULE_1__components_common_Hero___default.a
  },
  data: function data() {
    return {
      policy: ''
    };
  },

  methods: {
    getPolicy: function getPolicy() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://app.termageddon.com/api/policy/' + this.page.policy_id).then(function (response) {
        _this.policy = response.data;
      });
    }
  },
  mounted: function mounted() {
    if (this.page.policy_id) {
      this.getPolicy();
    }
  },

  computed: {
    hasHero: function hasHero() {
      return this.page.hero.title && this.page.hero.lead;
    },
    pageContent: function pageContent() {
      var vm = this;
      if (vm.page && vm.page.content) {
        var content = vm.page.content;
        if (false) {
          content = content.split('src="http://longestshortesttime').join('src="http://cdn.longestshortesttime');
        }
        return content;
      }
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Hero__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_participate_KeepInTouch__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_participate_KeepInTouch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_participate_KeepInTouch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ShopModule__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ShopModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_ShopModule__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'participate',
  data: function data() {
    return {
      loading: true,
      page: null
    };
  },
  mounted: function mounted() {
    this.fetchPost();
  },

  methods: {
    fetchPost: function fetchPost() {
      var vm = this;

      vm.$axios.get('/posts', {
        params: {
          slug: 'participate'
        }
      }).then(function (response) {
        vm.page = response.data;
        if (vm.$route.hash) vm.scrollToAnchor();
        process.nextTick(function () {
          vm.loading = false;
        });
      }).catch(function (err) {
        vm.loading = false;
        console.log(err);
      });
    },
    scrollToAnchor: function scrollToAnchor() {
      var id = this.$route.hash.replace('#', '');
      process.nextTick(function () {
        document.getElementById(id).scrollIntoView();
      });
    }
  },
  components: {
    Hero: __WEBPACK_IMPORTED_MODULE_0__components_common_Hero___default.a,
    KeepInTouch: __WEBPACK_IMPORTED_MODULE_1__components_participate_KeepInTouch___default.a,
    ShopModule: __WEBPACK_IMPORTED_MODULE_2__components_common_ShopModule___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34)))

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Episode__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Episode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Episode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Extra__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Extra___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Extra__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Page__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotFound__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__NotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post',
  data: function data() {
    return {
      notFound: false,
      loading: true
    };
  },

  components: {
    Episode: __WEBPACK_IMPORTED_MODULE_1__Episode___default.a,
    Extra: __WEBPACK_IMPORTED_MODULE_2__Extra___default.a,
    Page: __WEBPACK_IMPORTED_MODULE_3__Page___default.a,
    NotFound: __WEBPACK_IMPORTED_MODULE_4__NotFound___default.a
  },
  mounted: function mounted() {
    this.fetchPost();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    fetchPost: function fetchPost() {
      var vm = this;

      vm.$axios.get('/posts', {
        params: {
          slug: vm.$route.params.slug
        }
      }).then(function (response) {
        vm.loading = false;
        if (response.data) {
          vm.setCurrentPost(response.data);
          if (vm.nonce && vm.$route.query.preview === 'true') {
            vm.$router.push({ name: 'Preview', query: { preview_id: response.data.id } });
          } else if (vm.$route.hash) {
            vm.scrollToAnchor();
          }
        } else {
          vm.notFound = true;
        }
      }).catch(function (err) {
        vm.loading = false;
        vm.notFound = true;
        console.log(err);
      });
    },
    scrollToAnchor: function scrollToAnchor() {
      var id = this.$route.hash.replace('#', '');
      process.nextTick(function () {
        document.getElementById(id).scrollIntoView();
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['setCurrentPost'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    nonce: function nonce() {
      if (window.wpApiSettings && window.wpApiSettings.nonce) {
        return window.wpApiSettings.nonce;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['currentPost']))
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34)))

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Episode__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Episode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Episode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Extra__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Extra___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Extra__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Page__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Page__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post',
  data: function data() {
    return {
      post: null,
      loading: true
    };
  },

  components: {
    Episode: __WEBPACK_IMPORTED_MODULE_0__Episode___default.a,
    Extra: __WEBPACK_IMPORTED_MODULE_1__Extra___default.a,
    Page: __WEBPACK_IMPORTED_MODULE_2__Page___default.a
  },
  mounted: function mounted() {
    this.fetchPost();
  },

  methods: {
    fetchPost: function fetchPost() {
      var vm = this;
      if (vm.$route.query.preview_id) {
        vm.$axios.get('/preview', {
          params: {
            preview_id: vm.$route.query.preview_id
          },
          headers: {
            'X-WP-Nonce': window.wpApiSettings.nonce
          }
        }).then(function (response) {
          vm.loading = false;
          if (response.data) {
            vm.post = response.data;
            if (vm.$route.hash) vm.scrollToAnchor();
          } else {
            vm.$router.push('/');
          }
        }).catch(function (err) {
          console.log(err.response);
          vm.loading = false;
          vm.notFound = true;
          vm.$router.push('/');
        });
      } else {
        vm.$router.push('/');
      }
    },
    scrollToAnchor: function scrollToAnchor() {
      var id = this.$route.hash.replace('#', '');
      process.nextTick(function () {
        document.getElementById(id).scrollIntoView();
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34)))

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Hero__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_Hero__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'resources',
  components: {
    Hero: __WEBPACK_IMPORTED_MODULE_0__components_common_Hero___default.a
  },
  data: function data() {
    return {
      loading: true,
      page: null
    };
  },
  mounted: function mounted() {
    this.fetchPost();
  },

  methods: {
    fetchPost: function fetchPost() {
      var vm = this;

      vm.$axios.get('/posts', {
        params: {
          slug: 'resources'
        }
      }).then(function (response) {
        vm.page = response.data;
        process.nextTick(function () {
          vm.loading = false;
          if (vm.$route.hash) vm.scrollToAnchor();
        });
      }).catch(function (err) {
        vm.loading = false;
        console.log(err);
      });
    },
    scrollToAnchor: function scrollToAnchor() {
      var id = this.$route.hash.replace('#', '');
      process.nextTick(function () {
        document.getElementById(id).scrollIntoView();
      });
    }
  },
  filters: {
    toSlug: function toSlug(value) {
      var slug = '';
      var titleLower = value.toLowerCase();
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
      slug = slug.replace(/đ/gi, 'd');
      slug = slug.replace(/\s*$/g, '');
      slug = slug.replace(/\s+/g, '-');
      return slug;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34)))

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_search_SearchResult__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_search_SearchResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_search_SearchResult__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Pagination__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Pagination__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  data: function data() {
    return {
      page: 1,
      loading: true,
      results: null,
      totalPages: null
    };
  },

  components: {
    SearchResult: __WEBPACK_IMPORTED_MODULE_2__components_search_SearchResult___default.a,
    Pagination: __WEBPACK_IMPORTED_MODULE_3__components_common_Pagination___default.a
  },
  mounted: function mounted() {
    if (this.$route.query.page) {
      this.setPage(parseInt(this.$route.query.page), true);
    }
    this.executeSearch();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    submit: function submit() {
      var vm = this;
      vm.$router.push({ name: 'Search', query: { q: vm.searchQuery } });
    },
    executeSearch: function executeSearch() {
      var scrollToTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var vm = this;

      vm.$axios.get('/search', {
        params: {
          q: vm.$route.query.q,
          page: vm.page
        }
      }).then(function (response) {
        vm.results = response.data.posts;
        vm.totalPages = response.data.pages;
        if (scrollToTop) {
          scrollTo(0, 0);
        }
        vm.loading = false;
      }).catch(function (err) {
        vm.loading = false;
        console.log(err.response);
      });
    },
    setPage: function setPage(i) {
      var push = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var vm = this;
      vm.page = parseInt(i);
      if (push) {
        vm.$router.push({ name: 'Search', query: { q: vm.$route.query.q, page: i } });
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['setSearchQuery'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    query: function query() {
      return this.$route.query.q;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['searchQuery'])),
  watch: {
    query: function query() {
      this.loading = true;
      this.results = null;
      this.executeSearch();
    },
    page: function page() {
      this.loading = true;
      this.results = null;
      this.executeSearch(true);
    }
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_search_SearchResult__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_search_SearchResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_search_SearchResult__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Pagination__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_Pagination__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  data: function data() {
    return {
      page: 1,
      loading: true,
      results: null,
      totalPages: null,
      tag: null
    };
  },

  components: {
    SearchResult: __WEBPACK_IMPORTED_MODULE_0__components_search_SearchResult___default.a,
    Pagination: __WEBPACK_IMPORTED_MODULE_1__components_common_Pagination___default.a
  },
  mounted: function mounted() {
    if (this.$route.query.page) {
      this.setPage(parseInt(this.$route.query.page), true);
    }
    this.executeSearch();
  },

  methods: {
    executeSearch: function executeSearch() {
      var scrollToTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var vm = this;

      vm.$axios.get('/tags', {
        params: {
          tag: vm.$route.params.tag,
          page: vm.page
        }
      }).then(function (response) {
        vm.results = response.data.posts;
        vm.totalPages = response.data.pages;
        vm.tag = response.data.tag;
        if (scrollToTop) {
          scrollTo(0, 0);
        }
        vm.loading = false;
      }).catch(function (err) {
        vm.loading = false;
        console.log(err.response);
      });
    },
    setPage: function setPage(i) {
      var push = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var vm = this;
      vm.page = parseInt(i);
      if (push) {
        vm.$router.push({ name: 'Tag', query: { tag: vm.$route.params.tag, page: i } });
      }
    }
  },
  computed: {
    tagSlug: function tagSlug() {
      return this.$route.params.tag;
    }
  },
  watch: {
    tagSlug: function tagSlug() {
      this.loading = true;
      this.results = null;
      this.executeSearch();
    },
    page: function page() {
      this.loading = true;
      this.results = null;
      this.executeSearch(true);
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'awards',
  props: ['awards'],
  computed: {
    awardsImage: function awardsImage() {
      var image = this.awards.image.sizes.medium;
      if (false) {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
      }
      return image;
    }
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  props: ['contact']
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PressItem__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PressItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PressItem__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'press',
  data: function data() {
    return {
      expanded: false
    };
  },

  props: ['items'],
  components: {
    PressItem: __WEBPACK_IMPORTED_MODULE_0__PressItem___default.a
  },
  methods: {
    toggleExpanded: function toggleExpanded() {
      this.expanded = !this.expanded;
    }
  },
  computed: {
    expandable: function expandable() {
      return this.items && this.items.length > 6;
    },
    pressItems: function pressItems() {
      if (this.expandable && !this.expanded) {
        return this.items.slice(0, 6);
      } else {
        return this.items;
      }
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'press-item',
  props: ['item'],
  computed: {
    imgStyle: function imgStyle() {
      return {
        backgroundImage: 'url(' + this.logo + ')'
      };
    },
    logo: function logo() {
      var image = this.item.logo.sizes.medium;
      if (false) {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
      }
      return image;
    },
    formattedPubDate: function formattedPubDate() {
      var vm = this;
      if (vm.item.publish_date) return vm.$moment(vm.item.publish_date).format('MM.DD.YY');
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'the-team',
  props: ['team'],
  methods: {
    photo: function photo(_photo) {
      if (_photo && _photo.sizes) {
        var image = _photo.sizes.medium;
        if (false) {
          image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
        }
        return image;
      }
    }
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_howler__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_howler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_howler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bus__ = __webpack_require__(345);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'audio-player',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_howler___default.a],
  props: ['playingEpisode'],
  mounted: function mounted() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_3__bus__["a" /* default */].$on('playerPlay', vm.playerPlay);
    __WEBPACK_IMPORTED_MODULE_3__bus__["a" /* default */].$on('playerPause', vm.playerPause);
    process.nextTick(function () {
      vm.playerPlay();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_3__bus__["a" /* default */].$off('playerPlay', vm.playerPlay);
    __WEBPACK_IMPORTED_MODULE_3__bus__["a" /* default */].$off('playerPause', vm.playerPause);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    percentElapsed: function percentElapsed() {
      return this.progress * 100;
    },
    formattedDuration: function formattedDuration() {
      return this.formattedTimestamp(this.duration);
    },
    formattedCurrentTime: function formattedCurrentTime() {
      return this.formattedTimestamp(this.seek);
    },
    loading: function loading() {
      if (this._data && this._data._howl) return this._data._howl._state === 'loading';
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['playerPlaying'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    playerPlay: function playerPlay() {
      var vm = this;
      vm.$ga.event('player', 'play', vm.playingEpisode.slug, parseInt(vm.seek));
      vm.play();
    },
    playerPause: function playerPause() {
      var vm = this;
      vm.$ga.event('player', 'pause', vm.playingEpisode.slug, parseInt(vm.seek));
      vm.pause();
    },
    playerSkipBack: function playerSkipBack() {
      var vm = this;
      vm.$ga.event('player', 'skipBack', vm.playingEpisode.slug, parseInt(vm.seek));
      vm.setSeek(vm.seek - 10);
    },
    playerSkipAhead: function playerSkipAhead() {
      var vm = this;
      vm.$ga.event('player', 'skipAhead', vm.playingEpisode.slug, parseInt(vm.seek));
      vm.setSeek(vm.seek + 30);
    },
    playerSeek: function playerSeek(e) {
      var vm = this;
      vm.$ga.event('player', 'seek', vm.playingEpisode.slug, parseInt(e));
    },
    formattedTimestamp: function formattedTimestamp(dur) {
      var stamp = Math.round(dur);
      var m = this.$moment.duration(stamp, 'seconds');
      var str = '';
      str += (m.hours() > 0 ? m.hours() + ':' : '') + ('0' + m.minutes()).slice(-2) + ':' + ('0' + m.seconds()).slice(-2);
      return str;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['setPlayerPlaying', 'setPlayerLoading'])),
  watch: {
    playing: function playing() {
      this.setPlayerPlaying(this.playing);
    },
    loading: function loading() {
      this.setPlayerLoading(this.loading);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34)))

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Comment__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Comment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Comment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'child-comments',
  props: ['comments', 'childComments', 'postId'],
  components: {
    Comment: __WEBPACK_IMPORTED_MODULE_0__Comment___default.a
  },
  computed: {
    sortedComments: function sortedComments() {
      return this.comments.reverse();
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommentForm__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommentForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommentForm__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'comment',
  props: ['comment', 'postId', 'childComments'],
  data: function data() {
    return {
      replying: false
    };
  },

  beforeCreate: function beforeCreate() {
    this.$options.components.ChildComments = __webpack_require__(728);
  },
  methods: {
    toggleReply: function toggleReply() {
      this.replying = !this.replying;
    }
  },
  components: {
    CommentForm: __WEBPACK_IMPORTED_MODULE_0__CommentForm___default.a
  },
  computed: {
    commentDate: function commentDate() {
      var vm = this;
      return vm.$moment(vm.comment.date).format('MMMM D, YYYY [at] h:mm a');
    },
    children: function children() {
      var vm = this;
      if (vm.childComments) {
        return vm.childComments.filter(function (cc) {
          return parseInt(cc.parent) === parseInt(vm.comment.id);
        });
      }
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'comment-form',
  props: ['postId', 'parentId'],
  data: function data() {
    return {
      comment: {
        name: '',
        email: '',
        content: ''
      },
      error: null,
      successMsg: null,
      commenterSaved: false
    };
  },
  mounted: function mounted() {
    var name = localStorage.getItem('commentName');
    var email = localStorage.getItem('commentEmail');
    if (name || email) this.setCommenterFromLocalStorage(name, email);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    setCommenterFromLocalStorage: function setCommenterFromLocalStorage(name, email) {
      var vm = this;
      vm.commenterSaved = true;
      if (name) vm.comment.name = name;
      if (email) vm.comment.email = email;
    },
    clearCommenterFromLocalStorage: function clearCommenterFromLocalStorage() {
      this.commenterSaved = false;
      this.comment.name = '';
      this.comment.email = '';
      localStorage.removeItem('commentName');
      localStorage.removeItem('commentEmail');
    },
    fetchPost: function fetchPost() {
      var vm = this;

      vm.$axios.get('/posts', {
        params: {
          slug: vm.$route.params.slug
        }
      }).then(function (response) {
        vm.loading = false;
        if (response.data) {
          vm.setCurrentPost(response.data);
          if (vm.$route.hash) vm.scrollToAnchor();
        } else {
          vm.notFound = true;
        }
      }).catch(function (err) {
        vm.loading = false;
        vm.notFound = true;
        console.log(err);
      });
    },
    submitComment: function submitComment() {
      var vm = this;

      vm.$comments.post('/comments', {
        author_name: vm.comment.name,
        author_email: vm.comment.email,
        content: vm.comment.content,
        post: vm.postId,
        parent: vm.parentId
      }).then(function (response) {
        localStorage.setItem('commentName', vm.comment.name);
        localStorage.setItem('commentEmail', vm.comment.email);
        vm.commenterSaved = true;
        vm.comment.content = '';
        vm.error = null;
        if (response.data.status === 'hold') {
          vm.successMsg = 'Your comment has been submitted and is pending moderation';
        } else {
          vm.successMsg = 'Your comment has been submitted!';
          vm.fetchPost();
        }
        window.setTimeout(function () {
          vm.successMsg = null;
        }, 5000);
      }).catch(function (error) {
        if (error.response) {
          vm.error = error.response.data;
        }
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['setCurrentPost']))
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Comment__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Comment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Comment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommentForm__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommentForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CommentForm__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'comments',
  props: ['comments', 'postId'],
  data: function data() {
    return {
      expanded: false
    };
  },

  components: {
    CommentForm: __WEBPACK_IMPORTED_MODULE_3__CommentForm___default.a,
    Comment: __WEBPACK_IMPORTED_MODULE_2__Comment___default.a
  },
  methods: {
    toggleExpand: function toggleExpand() {
      this.expanded = !this.expanded;
      this.$refs.comments.scrollIntoView();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    commentGuidelines: function commentGuidelines() {
      if (this.siteInfo && this.siteInfo.commentGuidelines) return this.siteInfo.commentGuidelines;
    },
    firstComment: function firstComment() {
      if (this.rootComments) return this.rootComments[0];
    },
    rootComments: function rootComments() {
      if (this.comments) {
        return this.comments.filter(function (comment) {
          return comment.parent === '0';
        });
      }
    },
    childComments: function childComments() {
      if (this.comments) {
        return this.comments.filter(function (comment) {
          return comment.parent !== '0';
        });
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['siteInfo']))
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'episode-module',
  props: ['episode'],
  computed: {
    episodeNumber: function episodeNumber() {
      if (this.episode.lstplus) {
        return 'LST+';
      } else if (this.episode.number) {
        return 'Episode #' + this.episode.number;
      }
    },
    formattedDate: function formattedDate() {
      return this.$moment(this.episode.date).format('MM.DD.YY');
    },
    featuredImage: function featuredImage() {
      var vm = this;
      var image = vm.episode.image.large;
      if (false) {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
      }
      return image;
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'extra-module',
  props: ['extra'],
  computed: {
    formattedDate: function formattedDate() {
      return this.$moment(this.episode.date).format('MM.DD.YY');
    },
    featuredImage: function featuredImage() {
      var vm = this;
      if (vm.extra.image) {
        var image = vm.extra.image.large;
        if (false) {
          image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
        }
        return image;
      }
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hero',
  props: ['page', 'colorScheme'],
  computed: {
    featuredImage: function featuredImage() {
      var vm = this;
      if (vm.page && vm.page.image) {
        var image = vm.page.image.large;
        if (false) {
          image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
        }
        return image;
      }
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'logo',
  data: function data() {
    return {
      currentLogo: 0,
      logos: [__webpack_require__(696), __webpack_require__(697), __webpack_require__(698), __webpack_require__(699), __webpack_require__(700), __webpack_require__(701), __webpack_require__(702), __webpack_require__(703)]
    };
  },
  mounted: function mounted() {
    this.cycleLogos();
  },

  methods: {
    cycleLogos: function cycleLogos() {
      var _this = this;

      var vm = this;
      var interval = setInterval(function () {
        if (_this.currentLogo + 1 >= _this.logos.length) {
          vm.currentLogo = 0;
          clearInterval(interval);
        } else {
          _this.currentLogo++;
        }
      }, 600);
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchModule__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SearchModule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubscribeModule__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubscribeModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SubscribeModule__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'masthead',
  data: function data() {
    return {
      expanded: false
    };
  },

  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_0__Logo___default.a,
    SearchModule: __WEBPACK_IMPORTED_MODULE_1__SearchModule___default.a,
    SubscribeModule: __WEBPACK_IMPORTED_MODULE_2__SubscribeModule___default.a
  },
  methods: {
    toggleExpanded: function toggleExpanded() {
      this.expanded = !this.expanded;
    },
    unexpand: function unexpand() {
      if (this.expanded) {
        this.expanded = false;
      }
    }
  },
  computed: {
    notPadded: function notPadded() {
      return this.$route.name === 'Episodes' || this.$route.name === 'Extras' || this.$route.name === 'Category';
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.unexpand();
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newsletter-module',
  data: function data() {
    return {
      focused: false,
      email: '',
      success: false,
      error: null
    };
  },
  beforeMount: function beforeMount() {
    if (sessionStorage.getItem('newsletterSubscribe')) {
      this.success = true;
    }
  },

  methods: {
    focus: function focus() {
      var _this = this;

      this.focused = true;
      process.nextTick(function () {
        _this.$refs.input.focus();
      });
    },
    unfocus: function unfocus() {
      if (!this.email) {
        this.focused = false;
      }
    },
    removeError: function removeError() {
      this.error = null;
    },
    submit: function submit() {
      var vm = this;

      vm.$axios.post('/subscribe', {
        email: vm.email
      }).then(function (response) {
        if (response.data.success) {
          vm.unfocus();
          vm.email = '';
          vm.success = true;
          vm.error = null;
          sessionStorage.setItem('newsletterSubscribe', true);
        } else {
          vm.error = response.data.data.message;
          setTimeout(function () {
            vm.error = null;
          }, 5000);
        }
      });
    }
  },
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34)))

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pagination',
  props: ['totalPages'],
  methods: {
    goToPage: function goToPage(page) {
      this.$parent.setPage(page, true);
    }
  },
  computed: {
    currentPage: function currentPage() {
      return this.$parent.page;
    },
    pagination: function pagination() {
      var vm = this;
      var left = vm.currentPage - 2;
      var right = vm.currentPage + 2 + 1;
      var range = [];
      var rangeWithDots = [];
      var l = void 0;
      for (var i = 1; i <= vm.totalPages; i++) {
        if (i === 1 || i === vm.totalPages || i >= left && i < right) {
          range.push(i);
        }
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(range), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _i = _step.value;

          if (l) {
            if (_i - l === 2) {
              rangeWithDots.push(l + 1);
            } else if (_i - l !== 1) {
              rangeWithDots.push('...');
            }
          }
          rangeWithDots.push(_i);
          l = _i;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return rangeWithDots;
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PlayerContainer__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PlayerContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PlayerContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PlayerPlaceholder__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PlayerPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PlayerPlaceholder__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'player',
  data: function data() {
    return {
      seeking: false,
      seekingTime: null,
      playerShown: true,
      loading: true,
      error: false
    };
  },

  components: {
    PlayerContainer: __WEBPACK_IMPORTED_MODULE_2__PlayerContainer___default.a,
    PlayerPlaceholder: __WEBPACK_IMPORTED_MODULE_3__PlayerPlaceholder___default.a
  },
  methods: {
    toggleShown: function toggleShown() {
      this.playerShown = !this.playerShown;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    audioSource: function audioSource() {
      if (this.playingEpisode && this.playingEpisode.audioSource) {
        return this.playingEpisode.audioSource;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['playingEpisode', 'playerPlaying', 'playerDirty']))
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AudioPlayer__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AudioPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AudioPlayer__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'player-container',
  props: ['playingEpisode', 'audioSource'],
  components: {
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_0__AudioPlayer___default.a
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'player-placeholder'
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  data: function data() {
    return {
      placeholderOn: true
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  mounted: function mounted() {
    var q = this.$route.query.q;
    if (q) {
      this.setSearchQuery(q);
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    submit: function submit() {
      var vm = this;
      vm.$router.push({ name: 'Search', query: { q: vm.searchQuery } });
    },
    togglePlaceholder: function togglePlaceholder() {
      if (this.placeholderOn) {
        this.placeholderOn = false;
      } else if (!this.searchQuery) {
        this.placeholderOn = true;
      }
    },
    togglePlaceholderOn: function togglePlaceholderOn() {
      this.placeholderOn = true;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['setSearchQuery'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    placeholder: function placeholder() {
      return this.placeholderOn ? 'Search' : '';
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['searchQuery'])),
  watch: {
    placeholderOn: function placeholderOn() {
      this.$parent.searching = !this.placeholderOn;
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'shop-module',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['shopItems'])),
  methods: {
    featured: function featured(value) {
      if (value && value.sizes) {
        var image = value.sizes.large;
        if (false) {
          image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
        }
        return image;
      }
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site-footer',
  data: function data() {
    return {
      currentYear: new Date().getFullYear(),
      email: '',
      firstName: '',
      lastName: '',
      success: false,
      error: null,
      socialLinks: [{
        name: 'Apple Podcasts',
        icon: 'ph:apple-podcasts-logo-fill',
        url: 'https://podcasts.apple.com/us/podcast/the-longest-shortest-time/id412457621?mt=2'
      }, {
        name: 'Spotify',
        icon: 'mdi:spotify',
        url: 'https://open.spotify.com/show/7sfcXmCcDIsdd1uvYOIQGp?si=dadbc012c74446b2'
      }, {
        name: 'RSS',
        icon: 'material-symbols:rss-feed',
        url: 'https://feeds.megaphone.fm/QCD4231325211'
      }]
    };
  },
  beforeMount: function beforeMount() {
    if (sessionStorage.getItem('newsletterSubscribe')) {
      this.success = true;
    }
  },

  methods: {
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
    },
    submit: function submit() {
      var vm = this;

      vm.$axios.post('/subscribe', {
        email: vm.email,
        first_name: vm.firstName,
        last_name: vm.lastName
      }).then(function (response) {
        if (response.data.success) {
          vm.email = '';
          vm.lastName = '';
          vm.firstName = '';
          vm.success = true;
          vm.error = null;
          sessionStorage.setItem('newsletterSubscribe', true);
        } else {
          vm.error = response.data.data.message;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['socialLinks']), {
    isHome: function isHome() {
      return this.$route.name === 'Home';
    }
  })
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SubscribeModule',
  data: function data() {
    return {
      socialLinks: [{
        name: 'Apple Podcasts',
        icon: 'ph:apple-podcasts-logo-fill',
        url: 'https://itunes.apple.com/us/podcast/the-longest-shortest-time/id412457621?mt=2'
      }, {
        name: 'Spotify',
        icon: 'mdi:spotify',
        url: 'https://open.spotify.com/show/7sfcXmCcDIsdd1uvYOIQGp?si=dadbc012c74446b2'
      }, {
        name: 'Overcast',
        icon: 'simple-icons:overcast',
        url: 'https://overcast.fm/itunes412457621'
      }, {
        name: 'RSS',
        icon: 'material-symbols:rss-feed',
        url: 'https://feeds.megaphone.fm/QCD4231325211'
      }, {
        name: 'Facebook',
        icon: 'mdi:facebook',
        url: 'https://www.facebook.com/longestshortesttime'
      }, {
        name: 'Instagram',
        icon: 'mdi:instagram',
        url: 'https://www.instagram.com/longestshortesttime/'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['socialLinks']))
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NewsletterModule__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NewsletterModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__NewsletterModule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchModule__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SearchModule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubscribeModule__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubscribeModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SubscribeModule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'top-nav',
  data: function data() {
    return {
      searching: false
    };
  },

  components: {
    NewsletterModule: __WEBPACK_IMPORTED_MODULE_1__NewsletterModule___default.a,
    SearchModule: __WEBPACK_IMPORTED_MODULE_2__SearchModule___default.a,
    SubscribeModule: __WEBPACK_IMPORTED_MODULE_3__SubscribeModule___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['topBarButtons'])),
  methods: {
    getPath: function getPath(url) {
      if (!url) return '/';

      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return url;
      }

      try {
        var urlObj = new URL(url);
        return urlObj.pathname + urlObj.search + urlObj.hash;
      } catch (e) {
        return url;
      }
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hero',
  props: ['episode', 'comments'],
  computed: {
    episodeNumber: function episodeNumber() {
      if (this.episode.lstplus) {
        return 'LST+';
      } else if (this.episode.number) {
        return '#' + this.episode.number;
      }
    },
    formattedPubDate: function formattedPubDate() {
      var vm = this;
      return vm.$moment(vm.episode.date).format('MM.DD.YY');
    },
    featuredImage: function featuredImage() {
      var vm = this;
      var image = vm.episode.image.large;
      if (false) {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
      }
      return image;
    }
  },
  methods: {
    download: function download() {
      var vm = this;
      vm.$ga.event('episode', 'download', vm.episode.slug);
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'episode',
  props: ['episode', 'index'],
  computed: {
    episodeNumber: function episodeNumber() {
      if (this.episode.lstplus) {
        return 'LST+';
      } else if (this.episode.number) {
        return '#' + this.episode.number;
      }
    },
    formattedDate: function formattedDate() {
      return this.$moment(this.episode.date).format('MM.DD.YY');
    },
    featuredImage: function featuredImage() {
      var vm = this;
      var image = vm.episode.image.large;
      if (false) {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
      }
      return image;
    },
    episodeTopics: function episodeTopics() {
      if (this.episode.topics) {
        return this.episode.topics.filter(function (topic) {
          return topic.name !== 'PODCAST';
        });
      }
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'episode-filter',
  data: function data() {
    return {
      topicToggled: false,
      yearToggled: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["mixin"]],
  mounted: function mounted() {
    this.fetchTopics();
  },

  methods: {
    fetchTopics: function fetchTopics() {
      var vm = this;

      vm.$axios.get('/topics', {
        params: {
          type: 'episode'
        }
      }).then(function (response) {
        vm.$parent.topics = response.data.topics;
        vm.$parent.years = response.data.years;
      }).catch(function (err) {
        console.log(err.response);
      });
    },
    toggleTopic: function toggleTopic() {
      this.topicToggled = !this.topicToggled;
    },
    toggleYear: function toggleYear() {
      this.yearToggled = !this.yearToggled;
    },
    toggleTopicOff: function toggleTopicOff() {
      this.topicToggled = false;
    },
    toggleYearOff: function toggleYearOff() {
      this.yearToggled = false;
    },
    selectTopic: function selectTopic(e) {
      var vm = this;
      if (vm.year) {
        vm.$router.replace({ name: 'Category', params: { topic: e.target.dataset.value }, query: { year: vm.year } });
      } else {
        vm.$router.replace({ name: 'Category', params: { topic: e.target.dataset.value } });
      }
      vm.toggleTopicOff();
    },
    selectYear: function selectYear(e) {
      var vm = this;
      if (vm.topic) {
        vm.$router.replace({ name: 'Category', params: { topic: vm.topic }, query: { year: e.target.dataset.value } });
      } else {
        vm.$router.replace({ name: 'Episodes', query: { year: e.target.dataset.value } });
      }
      vm.toggleYearOff();
    }
  },
  computed: {
    year: function year() {
      return this.$parent.year;
    },
    topic: function topic() {
      return this.$parent.topic;
    },
    topics: function topics() {
      return this.$parent.topics;
    },
    years: function years() {
      return this.$parent.years;
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hero',
  props: ['extra', 'comments'],
  computed: {
    formattedPubDate: function formattedPubDate() {
      var vm = this;
      return vm.$moment(vm.extra.date).format('MM.DD.YY');
    },
    featuredImage: function featuredImage() {
      var vm = this;
      var image = vm.extra.image.large;
      if (false) {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
      }
      return image;
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'extra',
  props: ['extra', 'index'],
  computed: {
    formattedDate: function formattedDate() {
      return this.$moment(this.extra.date).format('MM.DD.YY');
    },
    featuredImage: function featuredImage() {
      var vm = this;
      var image = vm.extra.image.large;
      if (false) {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
      }
      return image;
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'extra-filter',
  data: function data() {
    return {
      topicToggled: false,
      yearToggled: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["mixin"]],
  mounted: function mounted() {
    this.fetchTopics();
  },

  methods: {
    fetchTopics: function fetchTopics() {
      var vm = this;

      vm.$axios.get('/topics').then(function (response) {
        vm.$parent.topics = response.data.topics;
        vm.$parent.years = response.data.years;
      }).catch(function (err) {
        console.log(err.response);
      });
    },
    toggleTopic: function toggleTopic() {
      this.topicToggled = !this.topicToggled;
    },
    toggleYear: function toggleYear() {
      this.yearToggled = !this.yearToggled;
    },
    toggleTopicOff: function toggleTopicOff() {
      this.topicToggled = false;
    },
    toggleYearOff: function toggleYearOff() {
      this.yearToggled = false;
    },
    selectTopic: function selectTopic(e) {
      var vm = this;
      if (vm.year) {
        vm.$router.replace({ name: 'Extras', query: { topic: e.target.dataset.value, year: vm.year } });
      } else {
        vm.$router.replace({ name: 'Extras', query: { topic: e.target.dataset.value } });
      }
      vm.toggleTopicOff();
    },
    selectYear: function selectYear(e) {
      var vm = this;
      if (vm.topic) {
        vm.$router.replace({ name: 'Extras', query: { topic: vm.topic, year: e.target.dataset.value } });
      } else {
        vm.$router.replace({ name: 'Extras', query: { year: e.target.dataset.value } });
      }
      vm.toggleYearOff();
    }
  },
  computed: {
    years: function years() {
      return this.$parent.years;
    },
    year: function year() {
      return this.$parent.year;
    },
    topic: function topic() {
      return this.$parent.topic;
    },
    topics: function topics() {
      return this.$parent.topics;
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'call-to-action',
  props: ['content'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['siteInfo']))
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hero',
  props: ['episode'],
  computed: {
    episodeNumber: function episodeNumber() {
      if (this.episode.lstplus) {
        return 'LST+';
      } else if (this.episode.number) {
        return 'Episode #' + this.episode.number;
      }
    },
    formattedPubDate: function formattedPubDate() {
      var vm = this;
      return vm.$moment(vm.episode.date).format('MM.DD.YY');
    },
    featuredImage: function featuredImage() {
      var vm = this;
      var image = vm.episode.image.large;
      if (false) {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
      }
      return image;
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_EpisodeModule__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_EpisodeModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_EpisodeModule__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'latest-episodes',
  props: ['episodes'],
  components: {
    EpisodeModule: __WEBPACK_IMPORTED_MODULE_0__components_common_EpisodeModule___default.a
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_ExtraModule__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_ExtraModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_ExtraModule__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'latest-extras',
  props: ['extras'],
  components: {
    ExtraModule: __WEBPACK_IMPORTED_MODULE_0__components_common_ExtraModule___default.a
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'start-here'
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'testimonials',
  data: function data() {
    return {
      activeSlide: 0
    };
  },

  methods: {
    isActiveSlide: function isActiveSlide(i) {
      return i === this.activeSlide;
    },
    nextTestimonial: function nextTestimonial() {
      if (this.activeSlide + 1 >= this.testimonials.length) {
        this.activeSlide = 0;
      } else {
        this.activeSlide++;
      }
    },
    shuffle: function shuffle(array) {
      var i = 0;
      var j = 0;
      var temp = null;

      for (i = array.length - 1; i > 0; i -= 1) {
        j = Math.floor(Math.random() * (i + 1));
        temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    currentTestimonial: function currentTestimonial() {
      if (this.shuffledTestimonials) return this.shuffledTestimonials[this.activeSlide];
    },
    shuffledTestimonials: function shuffledTestimonials() {
      if (this.testimonials) return this.shuffle(this.testimonials);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['testimonials']))
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'keep-in-touch',
  props: ['page', 'colorScheme'],
  beforeMount: function beforeMount() {
    if (sessionStorage.getItem('newsletterSubscribe')) {
      this.success = true;
    }
  },
  data: function data() {
    return {
      email: '',
      firstName: '',
      lastName: '',
      success: false,
      error: null,
      page: null
    };
  },
  mounted: function mounted() {
    this.fetchPost();
  },

  methods: {
    fetchPost: function fetchPost() {
      var vm = this;

      vm.$axios.get('/posts', {
        params: {
          slug: 'participate'
        }
      }).then(function (response) {
        vm.page = response.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    submit: function submit() {
      var vm = this;

      vm.$axios.post('/subscribe', {
        email: vm.email,
        first_name: vm.firstName,
        last_name: vm.lastName,
        tag: 'new-hillary'
      }).then(function (response) {
        if (response.data.success) {
          vm.email = '';
          vm.lastName = '';
          vm.firstName = '';
          vm.success = true;
          vm.error = null;
          sessionStorage.setItem('newsletterSubscribe', true);
        } else {
          vm.error = response.data.data.message;
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['siteInfo']))
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-result',
  props: ['result'],
  computed: {
    episodeNumber: function episodeNumber() {
      if (this.result.lstplus) {
        return 'LST+';
      }
      return '#' + this.result.number;
    },
    formattedDate: function formattedDate() {
      return this.$moment(this.result.date).format('MM.DD.YY');
    },
    featuredImage: function featuredImage() {
      var vm = this;
      var image = vm.result.image.large;
      if (false) {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content');
      }
      return image;
    },
    resultTopics: function resultTopics() {
      if (this.result.topics) {
        return this.result.topics.filter(function (topic) {
          return topic.name !== 'PODCAST';
        });
      }
    }
  }
});

/***/ }),
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 178,
	"./af.js": 178,
	"./ar": 186,
	"./ar-dz": 179,
	"./ar-dz.js": 179,
	"./ar-kw": 180,
	"./ar-kw.js": 180,
	"./ar-ly": 181,
	"./ar-ly.js": 181,
	"./ar-ma": 182,
	"./ar-ma.js": 182,
	"./ar-ps": 183,
	"./ar-ps.js": 183,
	"./ar-sa": 184,
	"./ar-sa.js": 184,
	"./ar-tn": 185,
	"./ar-tn.js": 185,
	"./ar.js": 186,
	"./az": 187,
	"./az.js": 187,
	"./be": 188,
	"./be.js": 188,
	"./bg": 189,
	"./bg.js": 189,
	"./bm": 190,
	"./bm.js": 190,
	"./bn": 192,
	"./bn-bd": 191,
	"./bn-bd.js": 191,
	"./bn.js": 192,
	"./bo": 193,
	"./bo.js": 193,
	"./br": 194,
	"./br.js": 194,
	"./bs": 195,
	"./bs.js": 195,
	"./ca": 196,
	"./ca.js": 196,
	"./cs": 197,
	"./cs.js": 197,
	"./cv": 198,
	"./cv.js": 198,
	"./cy": 199,
	"./cy.js": 199,
	"./da": 200,
	"./da.js": 200,
	"./de": 203,
	"./de-at": 201,
	"./de-at.js": 201,
	"./de-ch": 202,
	"./de-ch.js": 202,
	"./de.js": 203,
	"./dv": 204,
	"./dv.js": 204,
	"./el": 205,
	"./el.js": 205,
	"./en-au": 206,
	"./en-au.js": 206,
	"./en-ca": 207,
	"./en-ca.js": 207,
	"./en-gb": 208,
	"./en-gb.js": 208,
	"./en-ie": 209,
	"./en-ie.js": 209,
	"./en-il": 210,
	"./en-il.js": 210,
	"./en-in": 211,
	"./en-in.js": 211,
	"./en-nz": 212,
	"./en-nz.js": 212,
	"./en-sg": 213,
	"./en-sg.js": 213,
	"./eo": 214,
	"./eo.js": 214,
	"./es": 218,
	"./es-do": 215,
	"./es-do.js": 215,
	"./es-mx": 216,
	"./es-mx.js": 216,
	"./es-us": 217,
	"./es-us.js": 217,
	"./es.js": 218,
	"./et": 219,
	"./et.js": 219,
	"./eu": 220,
	"./eu.js": 220,
	"./fa": 221,
	"./fa.js": 221,
	"./fi": 222,
	"./fi.js": 222,
	"./fil": 223,
	"./fil.js": 223,
	"./fo": 224,
	"./fo.js": 224,
	"./fr": 227,
	"./fr-ca": 225,
	"./fr-ca.js": 225,
	"./fr-ch": 226,
	"./fr-ch.js": 226,
	"./fr.js": 227,
	"./fy": 228,
	"./fy.js": 228,
	"./ga": 229,
	"./ga.js": 229,
	"./gd": 230,
	"./gd.js": 230,
	"./gl": 231,
	"./gl.js": 231,
	"./gom-deva": 232,
	"./gom-deva.js": 232,
	"./gom-latn": 233,
	"./gom-latn.js": 233,
	"./gu": 234,
	"./gu.js": 234,
	"./he": 235,
	"./he.js": 235,
	"./hi": 236,
	"./hi.js": 236,
	"./hr": 237,
	"./hr.js": 237,
	"./hu": 238,
	"./hu.js": 238,
	"./hy-am": 239,
	"./hy-am.js": 239,
	"./id": 240,
	"./id.js": 240,
	"./is": 241,
	"./is.js": 241,
	"./it": 243,
	"./it-ch": 242,
	"./it-ch.js": 242,
	"./it.js": 243,
	"./ja": 244,
	"./ja.js": 244,
	"./jv": 245,
	"./jv.js": 245,
	"./ka": 246,
	"./ka.js": 246,
	"./kk": 247,
	"./kk.js": 247,
	"./km": 248,
	"./km.js": 248,
	"./kn": 249,
	"./kn.js": 249,
	"./ko": 250,
	"./ko.js": 250,
	"./ku": 252,
	"./ku-kmr": 251,
	"./ku-kmr.js": 251,
	"./ku.js": 252,
	"./ky": 253,
	"./ky.js": 253,
	"./lb": 254,
	"./lb.js": 254,
	"./lo": 255,
	"./lo.js": 255,
	"./lt": 256,
	"./lt.js": 256,
	"./lv": 257,
	"./lv.js": 257,
	"./me": 258,
	"./me.js": 258,
	"./mi": 259,
	"./mi.js": 259,
	"./mk": 260,
	"./mk.js": 260,
	"./ml": 261,
	"./ml.js": 261,
	"./mn": 262,
	"./mn.js": 262,
	"./mr": 263,
	"./mr.js": 263,
	"./ms": 265,
	"./ms-my": 264,
	"./ms-my.js": 264,
	"./ms.js": 265,
	"./mt": 266,
	"./mt.js": 266,
	"./my": 267,
	"./my.js": 267,
	"./nb": 268,
	"./nb.js": 268,
	"./ne": 269,
	"./ne.js": 269,
	"./nl": 271,
	"./nl-be": 270,
	"./nl-be.js": 270,
	"./nl.js": 271,
	"./nn": 272,
	"./nn.js": 272,
	"./oc-lnc": 273,
	"./oc-lnc.js": 273,
	"./pa-in": 274,
	"./pa-in.js": 274,
	"./pl": 275,
	"./pl.js": 275,
	"./pt": 277,
	"./pt-br": 276,
	"./pt-br.js": 276,
	"./pt.js": 277,
	"./ro": 278,
	"./ro.js": 278,
	"./ru": 279,
	"./ru.js": 279,
	"./sd": 280,
	"./sd.js": 280,
	"./se": 281,
	"./se.js": 281,
	"./si": 282,
	"./si.js": 282,
	"./sk": 283,
	"./sk.js": 283,
	"./sl": 284,
	"./sl.js": 284,
	"./sq": 285,
	"./sq.js": 285,
	"./sr": 287,
	"./sr-cyrl": 286,
	"./sr-cyrl.js": 286,
	"./sr.js": 287,
	"./ss": 288,
	"./ss.js": 288,
	"./sv": 289,
	"./sv.js": 289,
	"./sw": 290,
	"./sw.js": 290,
	"./ta": 291,
	"./ta.js": 291,
	"./te": 292,
	"./te.js": 292,
	"./tet": 293,
	"./tet.js": 293,
	"./tg": 294,
	"./tg.js": 294,
	"./th": 295,
	"./th.js": 295,
	"./tk": 296,
	"./tk.js": 296,
	"./tl-ph": 297,
	"./tl-ph.js": 297,
	"./tlh": 298,
	"./tlh.js": 298,
	"./tr": 299,
	"./tr.js": 299,
	"./tzl": 300,
	"./tzl.js": 300,
	"./tzm": 302,
	"./tzm-latn": 301,
	"./tzm-latn.js": 301,
	"./tzm.js": 302,
	"./ug-cn": 303,
	"./ug-cn.js": 303,
	"./uk": 304,
	"./uk.js": 304,
	"./ur": 305,
	"./ur.js": 305,
	"./uz": 307,
	"./uz-latn": 306,
	"./uz-latn.js": 306,
	"./uz.js": 307,
	"./vi": 308,
	"./vi.js": 308,
	"./x-pseudo": 309,
	"./x-pseudo.js": 309,
	"./yo": 310,
	"./yo.js": 310,
	"./zh-cn": 311,
	"./zh-cn.js": 311,
	"./zh-hk": 312,
	"./zh-hk.js": 312,
	"./zh-mo": 313,
	"./zh-mo.js": 313,
	"./zh-tw": 314,
	"./zh-tw.js": 314
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 694;

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjQzMjUuNjY0IDU0NjkuNjYyIDIwLjcwMyAyMC42OTEiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOiNmZmY7fS5hLC5ie3N0cm9rZTojN2M3YzdkO30uYiwuZHtmaWxsOm5vbmU7fS5je3N0cm9rZTpub25lO308L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMTg4LjY2NCA1MzcxLjY2MikiPjxnIGNsYXNzPSJhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTM3IDk4KSI+PGNpcmNsZSBjbGFzcz0iYyIgY3g9IjguNzE4IiBjeT0iOC43MTgiIHI9IjguNzE4Ii8+PGNpcmNsZSBjbGFzcz0iZCIgY3g9IjguNzE4IiBjeT0iOC43MTgiIHI9IjguMjE4Ii8+PC9nPjxwYXRoIGNsYXNzPSJiIiBkPSJNMjk0NC40OTMsNTU3MS40NzlsNS42OTMsNS42OTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNzkyLjgzNyAtNTQ1OC44MzQpIi8+PC9nPjwvc3ZnPg=="

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.a852c8b.svg";

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.9605b37.svg";

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.ae7383d.svg";

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.4723f9c.svg";

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.9db3532.svg";

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.6a6749a.svg";

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.fb00920.svg";

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.8ac41fd.svg";

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Mobile.1fdcbd4.svg";

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjEyMzg3LjM0MiAxMjE5My4xODYgNDUuMTAzIDQzLjEwMyI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2Y1ZjZmOTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiBub25lOwogICAgICAgIHN0cm9rZTogIzRiZGJkMDsKICAgICAgICBzdHJva2Utd2lkdGg6IDVweDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9Ikdyb3VwXzQwNjUiIGRhdGEtbmFtZT0iR3JvdXAgNDA2NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEyNjYgNTY4NSkiPgogICAgPHBhdGggaWQ9IlBhdGhfMjcyNzAiIGRhdGEtbmFtZT0iUGF0aCAyNzI3MCIgY2xhc3M9ImNscy0xIiBkPSJNMjEuNTUxLDBBMjEuNTUxLDIxLjU1MSwwLDEsMSwwLDIxLjU1MSwyMS41NTEsMjEuNTUxLDAsMCwxLDIxLjU1MSwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEyMS4zNDIgNjUwOC4xODYpIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8yNzI3MSIgZGF0YS1uYW1lPSJQYXRoIDI3MjcxIiBjbGFzcz0iY2xzLTIiIGQ9Ik05MjguNS05Mi41MjVsMTAuMjgxLDEwLjI4MSwyMy45NDYtMjMuOTQ2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMDEuOTUzIDY2MTkuMTYzKSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjE3NzgzLjY2NCA1NzkzLjY2MiA2Ny41MjcgNjcuNDg3Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjYxOSA1NjI5KSI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE2NC42NjQgMTY0LjY2MikiPjxnIGZpbGw9IiNmZmYiIHN0cm9rZT0iIzAwY2RiZCIgc3Ryb2tlLXdpZHRoPSIzcHgiPjxjaXJjbGUgc3Ryb2tlPSJub25lIiBjeD0iMjguNDc0IiBjeT0iMjguNDc0IiByPSIyOC40NzQiLz48Y2lyY2xlIGZpbGw9Im5vbmUiIGN4PSIyOC40NzQiIGN5PSIyOC40NzQiIHI9IjI2Ljk3NCIvPjwvZz48cGF0aCBzdHJva2U9IiMwMGNkYmQiIHN0cm9rZS13aWR0aD0iM3B4IiBkPSJNMjk0NC40OTMsNTU3MS40NzlsMTguNTk1LDE4LjU5NCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI4OTYuNjIyIC01NTIzLjY0NikiLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(667)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(783),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(652)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(767),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(651)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(766),
  /* scopeId */
  "data-v-22e1e27c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(668)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(784),
  /* scopeId */
  "data-v-5a00d9f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(665)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(780),
  /* scopeId */
  "data-v-553ce8fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(646)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(760),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(637)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(752),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(664)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(779),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(689)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(806),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(666)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(781),
  /* scopeId */
  "data-v-57cf34bd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(644)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(758),
  /* scopeId */
  "data-v-05759480",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(670)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(786),
  /* scopeId */
  "data-v-63d5589c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(660)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(776),
  /* scopeId */
  "data-v-4f494690",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(676)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(794),
  /* scopeId */
  "data-v-7b5a3c94",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(643)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(757),
  /* scopeId */
  "data-v-054f3fd9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(678)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(796),
  /* scopeId */
  "data-v-8c9255e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(684)
__webpack_require__(683)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(801),
  /* scopeId */
  "data-v-d68085f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(649)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(763),
  /* scopeId */
  "data-v-1c20c68b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(790),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(659)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(775),
  /* scopeId */
  "data-v-4c8fb57b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(688)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(805),
  /* scopeId */
  "data-v-fd68e760",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(677)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(795),
  /* scopeId */
  "data-v-7f4375b2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(661)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(777),
  /* scopeId */
  "data-v-4f729ad1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(675)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(793),
  /* scopeId */
  "data-v-77d87501",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(655)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(770),
  /* scopeId */
  "data-v-3573865d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(772),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(682)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(800),
  /* scopeId */
  "data-v-c5fce4f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(642)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(756),
  /* scopeId */
  "data-v-04221e84",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(650)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(764),
  /* scopeId */
  "data-v-1f5d7eec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(654)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(769),
  /* scopeId */
  "data-v-2e4a54a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(681)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(799),
  /* scopeId */
  "data-v-a363cac8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(669)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(785),
  /* scopeId */
  "data-v-5ed13334",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(647)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(761),
  /* scopeId */
  "data-v-08ff5e31",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(658)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(774),
  /* scopeId */
  "data-v-4ba40188",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(641)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(755),
  /* scopeId */
  "data-v-041b1fd4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(671)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(788),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(645)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(759),
  /* scopeId */
  "data-v-05e2ff82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(656)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(771),
  /* scopeId */
  "data-v-3a3e3787",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(674)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(792),
  /* scopeId */
  "data-v-7392c052",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(680)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(798),
  /* scopeId */
  "data-v-993b45cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(639)
__webpack_require__(638)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(753),
  /* scopeId */
  "data-v-025c423c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(685)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(802),
  /* scopeId */
  "data-v-d8ab2788",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content"
  }, [(_vm.page) ? _c('div', {
    class: !_vm.loading ? '' : 'loading'
  }, [_c('hero', {
    attrs: {
      "page": _vm.page,
      "colorScheme": 'green'
    }
  }), _vm._v(" "), _c('keep-in-touch'), _vm._v(" "), _c('shop-module')], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "homeTestimonials"
    }
  }, [_c('div', {
    staticClass: "container"
  }, _vm._l((_vm.shuffledTestimonials), function(testimonial, index) {
    return _c('div', {
      staticClass: "slide",
      class: _vm.isActiveSlide(index) ? 'active' : ''
    }, [_c('div', {
      staticClass: "circleHeader"
    }, [_c('h2', [_c('span', [_vm._v("The Longest Shortest Time is a parenting show for everyone.")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(testimonial.first_name) + " likes it...")])])]), _vm._v(" "), _c('div', {
      staticClass: "testimonial"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(testimonial.quote)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "attribution"
    }, [_c('em', [_vm._v("—" + _vm._s(testimonial.attribution))])]), _vm._v(" "), _c('div', [(_vm.testimonials.length > 1) ? _c('button', {
      on: {
        "click": _vm.nextTestimonial
      }
    }, [_c('span', [_vm._v("More Praise")]), _vm._v(" "), _c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "4262.82 9804.78 34.581 48.995",
        "width": "35",
        "height": "49"
      }
    }, [_c('path', {
      attrs: {
        "d": "M-19.71,54.92,11,32.33a2,2,0,0,0,0-3.14L-19.71,6.6a2,2,0,0,0-2.013-.123,2,2,0,0,0-1.1,1.693V53.35a2,2,0,0,0,1.1,1.693A2,2,0,0,0-19.71,54.92Z",
        "transform": "translate(4285.64 9798.518)"
      }
    })])]) : _vm._e()])])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-left social-nav"
  }, _vm._l((_vm.socialLinks), function(link, i) {
    return _c('a', {
      key: i,
      staticClass: "nav-item",
      attrs: {
        "href": link.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('iconify-icon', {
      attrs: {
        "icon": link.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sr-only"
    }, [_vm._v(_vm._s(link.name))])], 1)])
  }))
},staticRenderFns: []}

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "extraFilter"
    }
  }, [_c('h4', [_vm._v("Filter By")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.toggleYearOff),
      expression: "toggleYearOff"
    }],
    staticClass: "filterSelector yearSelector",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "selectorValue",
    on: {
      "click": _vm.toggleYear
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$parent.year || 'Year') + "\n      "), _c('img', {
    class: _vm.yearToggled ? 'toggled' : '',
    attrs: {
      "src": __webpack_require__(81),
      "width": "18",
      "height": "10"
    }
  })]), _vm._v(" "), (_vm.yearToggled) ? _c('div', {
    staticClass: "selectorOptions"
  }, [_c('p', {
    attrs: {
      "data-value": ""
    },
    on: {
      "click": function($event) {
        _vm.selectYear($event)
      }
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "mdi:close"
    }
  }), _vm._v(" Clear Filter\n      ")], 1), _vm._v(" "), _c('ul', _vm._l((_vm.years), function(yr) {
    return _c('li', {
      attrs: {
        "data-value": yr
      },
      on: {
        "click": function($event) {
          _vm.selectYear($event)
        }
      }
    }, [_vm._v(_vm._s(yr))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.toggleTopicOff),
      expression: "toggleTopicOff"
    }],
    staticClass: "filterSelector topicSelector",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "selectorValue",
    on: {
      "click": _vm.toggleTopic
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$parent.thisTopic ? _vm.$parent.thisTopic.name : 'Topic') + "\n      "), _c('img', {
    class: _vm.topicToggled ? 'toggled' : '',
    attrs: {
      "src": __webpack_require__(81),
      "width": "18",
      "height": "10"
    }
  })]), _vm._v(" "), (_vm.topicToggled) ? _c('div', {
    staticClass: "selectorOptions"
  }, [_c('p', {
    attrs: {
      "data-value": ""
    },
    on: {
      "click": function($event) {
        _vm.selectTopic($event)
      }
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "mdi:close"
    }
  }), _vm._v(" Clear Filter\n      ")], 1), _vm._v(" "), _c('ul', _vm._l((_vm.topics), function(topic) {
    return _c('li', {
      attrs: {
        "data-value": topic.slug
      },
      on: {
        "click": function($event) {
          _vm.selectTopic($event)
        }
      }
    }, [_vm._v(_vm._s(topic.name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  })])
},staticRenderFns: []}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-modules container"
  }, [_c('div', {
    staticClass: "show-subscribe"
  }, [_c('h3', [_vm._v("Subscribe to the show")]), _vm._v(" "), (_vm.socialLinks) ? _c('div', _vm._l((_vm.socialLinks), function(link, i) {
    return _c('a', {
      key: i,
      attrs: {
        "target": "_blank",
        "href": link.url,
        "rel": "noopener noreferrer"
      }
    }, [_c('span', {
      staticClass: "icon",
      class: ("" + (link.name.toLowerCase().replace(/ /g, '-')))
    }, [_c('iconify-icon', {
      attrs: {
        "icon": link.icon
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "sr-only"
    }, [_vm._v(_vm._s(link.name))])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "newsletter-subscribe",
    attrs: {
      "id": "newsletter"
    }
  }, [_c('h3', [_vm._v("Sign up for the newsletter")]), _vm._v(" "), _c('div', {
    staticClass: "newsletter-form-container"
  }, [_c('iframe', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "src": "https://longestshortesttime.substack.com/embed",
      "width": "480",
      "height": "160",
      "frameborder": "0",
      "scrolling": "no"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "site-info container"
  }, [(!_vm.isHome) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      },
      "tag": "h4"
    }
  }, [_vm._v("The Longest Shortest Time")]) : _c('h4', {
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  }, [_vm._v("The Longest Shortest Time")]), _vm._v(" "), _c('nav', [_c('div', {
    staticClass: "nav-center nav-menu"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Episodes'
      }
    }
  }, [_c('span', [_vm._v("Stories")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'About'
      }
    }
  }, [_c('span', [_vm._v("About")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("©2010-" + _vm._s(_vm.currentYear) + " The Longest Shortest Time LLC")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://longestshortesttime.supportingcast.fm/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', [_vm._v("Join the Club")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://the-longest-shortest-time.myshopify.com/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', [_vm._v("Shop")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-center nav-menu secondary-nav"
  }, [_c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "/terms"
    }
  }, [_c('span', [_vm._v("Terms of Service")])]), _vm._v(" "), _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "/privacy"
    }
  }, [_c('span', [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "/cookie-policy"
    }
  }, [_c('span', [_vm._v("Cookie Policy")])]), _vm._v(" "), _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "javascript:UC_UI.showSecondLayer();",
      "id": "usercentrics-psl"
    }
  }, [_c('span', [_vm._v("Privacy\n            Settings")])])])
}]}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "dotTop"
  }, [_vm._v("Press & Awards")]), _vm._v(" "), _c('div', {
    staticClass: "pressItems"
  }, _vm._l((_vm.pressItems), function(item, index) {
    return _c('press-item', {
      key: index,
      attrs: {
        "item": item
      }
    })
  })), _vm._v(" "), (_vm.expandable) ? _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "button button-color button-yellow",
    on: {
      "click": _vm.toggleExpanded
    }
  }, [_vm._v(_vm._s(_vm.expanded ? 'Show Less' : 'More Press Announcements'))])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "searchHero"
  }, [_c('h1', [_vm._v("Search Results")]), _vm._v(" "), _c('div', [_c('input', {
    attrs: {
      "placeholder": "Search"
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": function($event) {
        _vm.setSearchQuery($event.target.value)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    ref: "button",
    staticClass: "button",
    on: {
      "click": _vm.submit
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(706),
      "width": "64",
      "height": "64"
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "searchResults",
    class: !_vm.loading ? '' : 'loading'
  }, [_vm._l((_vm.results), function(result) {
    return _c('search-result', {
      key: result.slug,
      attrs: {
        "result": result
      }
    })
  }), _vm._v(" "), (!_vm.results || !_vm.results.length) ? _c('div', [_c('h2', [_vm._v("No Results")]), _vm._v(" "), _c('p', [_vm._v("Please try another search")])]) : _vm._e(), _vm._v(" "), (_vm.totalPages > 1) ? _c('pagination', {
    attrs: {
      "totalPages": _vm.totalPages
    }
  }) : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.episode) ? _c('section', [_c('article', {
    staticClass: "container article episode"
  }, [_c('router-link', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    }),
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.title)
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.excerpt)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "more-link",
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }, [_vm._v("More")])], 1), _vm._v(" "), _c('div', {
    staticClass: "playModule"
  }, [_c('div', {
    staticClass: "playButton"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }, [(_vm.episodeNumber) ? _c('span', [_vm._v(_vm._s(_vm.episodeNumber) + " • ")]) : _vm._e(), _vm._v(_vm._s(_vm.formattedPubDate))])], 1)])], 1)], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "home page content",
    class: !_vm.loading && (_vm.latestEpisodes && _vm.latestExtras) ? '' : 'loading'
  }, [_c('hero', {
    attrs: {
      "episode": _vm.featuredEpisode
    }
  }), _vm._v(" "), _c('latest-episodes', {
    attrs: {
      "episodes": _vm.latestEpisodes
    }
  }), _vm._v(" "), _c('call-to-action'), _vm._v(" "), _c('latest-extras', {
    attrs: {
      "extras": _vm.latestExtras
    }
  }), _vm._v(" "), _c('start-here'), _vm._v(" "), _c('testimonials'), _vm._v(" "), _c('shop-module')], 1)
},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    })
  }), _vm._v(" "), _c('section', {
    staticClass: "extraHeader"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.extra.title)
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "meta"
  }, [_c('span', [_vm._v(_vm._s(_vm.formattedPubDate))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#comments"
    }
  }, [_vm._v(_vm._s(_vm.comments) + " Comments")])]), _vm._v(" "), _c('p', {
    staticClass: "actions"
  }, [_c('span', [_vm._v("Share\n            "), _c('a', {
    staticClass: "icon",
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/home?status=' + encodeURI(_vm.extra.permalink)
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "fa6-brands:twitter"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Twitter")])], 1), _vm._v(" "), _c('a', {
    staticClass: "icon",
    attrs: {
      "target": "_blank",
      "href": 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(_vm.extra.permalink)
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "fa6-brands:facebook-f"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Facebook")])], 1)])])])])])])
},staticRenderFns: []}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page pageHero yellow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "img"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-content"
  }, [_c('h2', [_vm._v("Error 404! File not found.")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("We couldn’t find the page you’re looking for. Try going "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_vm._v("home")]), _vm._v(" or using "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Search'
      }
    }
  }, [_vm._v("search.")])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player"
  }, [_c('div', {
    staticClass: "player-controls"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.playerSkipBack
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "id": "replay_a"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "replay_b"
    }
  }, [_c('use', {
    attrs: {
      "overflow": "visible",
      "xlink:href": "#replay_a"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "clip-path": "url(#replay_b)",
      "d": "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('button', {
    staticClass: "button is-loading",
    attrs: {
      "disabled": ""
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.playerPlaying && !_vm.loading) ? _c('button', {
    on: {
      "click": _vm.playerPlay
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.playerPlaying && !_vm.loading) ? _c('button', {
    on: {
      "click": _vm.playerPause
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.playerSkipAhead
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M24 24H0V0h24v24z",
      "id": "forward_a"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "forward_b"
    }
  }, [_c('use', {
    attrs: {
      "overflow": "visible",
      "xlink:href": "#forward_a"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "clip-path": "url(#forward_b)",
      "d": "M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "scrub"
  }, [_c('input', {
    style: ({
      background: ("linear-gradient( to right, #00cdbd 0%, #00cdbd " + _vm.percentElapsed + "%, #bfe0dd " + _vm.percentElapsed + "%, #bfe0dd 100% )")
    }),
    attrs: {
      "type": "range",
      "min": "0",
      "max": _vm.duration
    },
    domProps: {
      "value": _vm.seek
    },
    on: {
      ":data-percent": _vm.percentElapsed,
      "change": function($event) {
        _vm.playerSeek($event.target.value)
      },
      "input": function($event) {
        _vm.setSeek(parseInt($event.target.value))
      }
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('p', {
    staticClass: "playerInfo"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.playingEpisode.title)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formattedCurrentTime) + " | " + _vm._s(_vm.formattedDuration))])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "playerInfo"
  }, [_vm._v("Loading...")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "subscribeMod"
  }, [_c('span', {
    staticClass: "noMob"
  }, [_vm._v("Subscribe")]), _vm._v(" "), _c('subscribe-module', {
    staticClass: "noMob"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu",
    class: _vm.searching ? 'is-searching' : ''
  }, [_vm._l((_vm.topBarButtons), function(button) {
    return _c('div', {
      key: button.id,
      staticClass: "nav-item nav-button"
    }, [(button.link.url.startsWith('#')) ? _c('a', {
      staticClass: "button",
      class: ("is-" + (button.style)),
      attrs: {
        "href": button.link.url
      }
    }, [_c('span', [_vm._v(_vm._s(button.text))])]) : (button.link.target !== '_blank') ? _c('router-link', {
      staticClass: "button",
      class: ("is-" + (button.style)),
      attrs: {
        "to": _vm.getPath(button.link.url)
      }
    }, [_c('span', [_vm._v(_vm._s(button.text))])]) : _c('a', {
      staticClass: "button",
      class: ("is-" + (button.style)),
      attrs: {
        "href": button.link.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('span', [_vm._v(_vm._s(button.text))])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-item search"
  }, [_c('search-module')], 1)], 2)])])
},staticRenderFns: []}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page) ? _c('section', {
    staticClass: "pageHero",
    class: _vm.colorScheme
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.page.image) ? _c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url(" + _vm.featuredImage + ")")
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hero-content"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.hero.title)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.hero.lead)
    }
  })])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content page books"
  }, [(_vm.page) ? _c('div', {
    class: !_vm.loading ? '' : 'loading'
  }, [_c('section', {
    staticClass: "pageHero"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.page.image) ? _c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url(" + _vm.featuredImage + ")")
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hero-content"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.hero.title)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.hero.lead)
    }
  })])])]), _vm._v(" "), (_vm.page.ordering.locations) ? _c('section', {
    staticClass: "ordering"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.ordering.title)
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.page.ordering.locations), function(location) {
    return _c('li', [_c('a', {
      attrs: {
        "href": location.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": location.logo,
        "alt": location.name
      }
    })])])
  })), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.ordering.inquiries)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.page.praise.comments) ? _c('section', {
    staticClass: "praise"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', [_c('div', {
    staticClass: "circleHeader"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.praise.title)
    }
  })]), _vm._v(" "), _vm._l((_vm.page.praise.comments), function(comment, i) {
    return _c('blockquote', {
      key: i
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(comment.quote)
      }
    }), _vm._v(" "), (comment.attribution) ? _c('footer', [_c('cite', [_vm._v("— " + _vm._s(comment.attribution))])]) : _vm._e()])
  })], 2), _vm._v(" "), (_vm.page.praise.image) ? _c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url(" + (_vm.page.praise.image.sizes.medium) + ")")
    })
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.page.other_books.books) ? _c('section', {
    staticClass: "other-books"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', [_c('div', {
    staticClass: "circleHeader"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.other_books.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "the-books"
  }, _vm._l((_vm.page.other_books.books), function(book) {
    return _c('div', {
      staticClass: "book"
    }, [_c('div', {
      staticClass: "cover dotTop"
    }, [_c('a', {
      attrs: {
        "href": book.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": book.image.sizes.medium,
        "alt": book.title
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [_c('h3', {
      staticClass: "title"
    }, [_c('a', {
      attrs: {
        "href": book.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      },
      domProps: {
        "innerHTML": _vm._s(book.title)
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "description",
      domProps: {
        "innerHTML": _vm._s(book.description)
      }
    })])])
  }))])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content page"
  }, [(_vm.page) ? _c('div', {
    class: !_vm.loading ? '' : 'loading'
  }, [_c('hero', {
    attrs: {
      "id": "show",
      "page": _vm.page
    }
  }), _vm._v(" "), (_vm.page.awards) ? _c('awards', {
    attrs: {
      "awards": _vm.page.awards
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page.awards) ? _c('press', {
    attrs: {
      "id": "press",
      "items": _vm.page.awards.items
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page.contact) ? _c('contact', {
    attrs: {
      "id": "contact",
      "contact": _vm.page.contact
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page.team) ? _c('the-team', {
    attrs: {
      "id": "team",
      "team": _vm.page.team
    }
  }) : _vm._e(), _vm._v(" "), _c('shop-module')], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "comments"
    }
  }, [_c('div', [_c('main', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.commentGuidelines)
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.comments.length) + " " + _vm._s(_vm.comments.length === 1 ? 'Comment' : 'Comments'))]), _vm._v(" "), _c('comment-form', {
    attrs: {
      "postId": _vm.postId
    }
  }), _vm._v(" "), _c('div', {
    ref: "comments",
    staticClass: "comments"
  }, [(!_vm.expanded && _vm.firstComment) ? _c('comment', {
    attrs: {
      "comment": _vm.firstComment,
      "postId": _vm.postId
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.rootComments), function(comment, index) {
    return (_vm.expanded) ? _c('comment', {
      key: index,
      attrs: {
        "comment": comment,
        "postId": _vm.postId,
        "childComments": _vm.childComments
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [(_vm.comments.length > 1) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.toggleExpand
    }
  }, [_vm._v(_vm._s(_vm.expanded ? 'Show Less' : 'Load All Comments'))]) : _vm._e()])], 1), _vm._v(" "), _c('aside')])])
},staticRenderFns: []}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    })
  }), _vm._v(" "), _c('section', {
    staticClass: "epHeader"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.title)
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "meta"
  }, [_c('span', [(_vm.episodeNumber) ? _c('span', [_vm._v(_vm._s(_vm.episodeNumber) + " • ")]) : _vm._e(), _vm._v(_vm._s(_vm.formattedPubDate))])]), _vm._v(" "), _c('p', {
    staticClass: "actions"
  }, [_c('a', {
    attrs: {
      "href": "#comments"
    }
  }, [_vm._v(_vm._s(_vm.comments) + " Comments")]), _vm._v(" "), _c('span', [_vm._v("Share\n            "), _c('a', {
    staticClass: "icon",
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/home?status=' + encodeURI(_vm.episode.permalink)
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "fa6-brands:twitter"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Twitter")])], 1), _vm._v(" "), _c('a', {
    staticClass: "icon",
    attrs: {
      "target": "_blank",
      "href": 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(_vm.episode.permalink)
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "fa6-brands:facebook-f"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Facebook")])], 1)])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "find-podcast-in-app"
  }, [_c('p', [_vm._v("Find this episode in your podcast app here!")]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://pod.link/412457621"
    }
  }, [_vm._v("\n              Subscribe\n            ")])])])
}]}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.playerDirty) ? _c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "toggleButton",
    on: {
      "click": _vm.toggleShown
    }
  }, [_c('iconify-icon', {
    staticClass: "fa",
    attrs: {
      "icon": _vm.playerShown ? 'fa6-solid:chevron-down' : 'fa6-solid:chevron-up'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Show/hide player")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playerShown),
      expression: "playerShown"
    }],
    staticClass: "playerModule"
  }, [(_vm.playingEpisode) ? _c('player-container', {
    attrs: {
      "playingEpisode": _vm.playingEpisode,
      "audioSource": _vm.audioSource
    }
  }) : _c('player-placeholder')], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.episodes) ? _c('section', [_c('div', {
    staticClass: "episodes container"
  }, _vm._l((_vm.episodes), function(episode) {
    return _c('episode-module', {
      key: episode.slug,
      attrs: {
        "episode": episode
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "container text-right"
  }, [_c('router-link', {
    staticClass: "button button-underline",
    attrs: {
      "to": {
        name: 'Episodes'
      }
    }
  }, [_vm._v("All Episodes")])], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.audioSource) ? _c('audio-player', {
    attrs: {
      "sources": [_vm.audioSource],
      "preload": false,
      "playingEpisode": _vm.playingEpisode,
      "html5": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod"
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.togglePlaceholderOn),
      expression: "togglePlaceholderOn"
    }]
  }, [_c('input', {
    ref: "input",
    class: _vm.placeholderOn ? '' : 'expanded',
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": function($event) {
        _vm.setSearchQuery($event.target.value)
      },
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.togglePlaceholder($event)
      }],
      "focus": _vm.togglePlaceholder,
      "blur": _vm.togglePlaceholder
    }
  }), _vm._v(" "), _c('button', {
    ref: "button",
    staticClass: "button",
    on: {
      "click": _vm.submit
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(695),
      "width": "20",
      "height": "20"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "extra"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    })
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.extra.title)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "meta"
  }, [_c('span', [_vm._v(_vm._s(_vm.formattedDate))]), _vm._v(" "), (_vm.extra.topics) ? _c('span', [_vm._v("• \n        "), _vm._l((_vm.extra.topics), function(topic, index) {
    return _c('span', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Extras',
          query: {
            topic: topic.slug
          }
        }
      },
      domProps: {
        "innerHTML": _vm._s(topic.name)
      }
    }), (index + 1 !== _vm.extra.topics.length) ? _c('span', [_vm._v(", ")]) : _vm._e()], 1)
  })], 2) : _vm._e()]), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.extra.excerpt)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "more-link",
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  }, [_vm._v("More")])], 1), _vm._v(" "), (_vm.index === 6) ? _c('v-waypoint', {
    on: {
      "waypoint": _vm.$parent.handleScroll
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "episode article"
  }, [_c('router-link', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    }),
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.title)
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.excerpt)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "more-link",
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }, [_vm._v("More")])], 1), _vm._v(" "), _c('div', {
    staticClass: "playModule"
  }, [_c('div', {
    staticClass: "playButton"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }, [(_vm.episodeNumber) ? _c('span', [_vm._v(_vm._s(_vm.episodeNumber) + " • ")]) : _vm._e(), _vm._v(_vm._s(_vm.formattedDate) + "\n        ")])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', [_c('div', {
    staticClass: "circleHeader"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.awards.title)
    }
  })]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.awards.content)
    }
  })]), _vm._v(" "), (_vm.awards.image) ? _c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url(" + _vm.awardsImage + ")")
    })
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav",
    class: _vm.notPadded ? 'noPad' : ''
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('logo')], 1)], 1), _vm._v(" "), _c('button', {
    staticClass: "toggle",
    class: _vm.expanded ? 'toggled' : '',
    on: {
      "click": _vm.toggleExpanded
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu",
    class: _vm.expanded ? 'is-active' : ''
  }, [_c('div', {
    staticClass: "nav-item has-dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Episodes'
      }
    }
  }, [_c('span', [_vm._v("Stories")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Episodes'
      }
    }
  }, [_vm._v("Episodes")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Books'
      }
    }
  }, [_vm._v("Books")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Extras'
      }
    }
  }, [_vm._v("Extras")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item has-dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'About'
      }
    }
  }, [_c('span', [_vm._v("About")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'About',
        hash: '#show'
      }
    }
  }, [_vm._v("The Show")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'About',
        hash: '#press'
      }
    }
  }, [_vm._v("Press")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'About',
        hash: '#contact'
      }
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'About',
        hash: '#team'
      }
    }
  }, [_vm._v("The Team")]), _vm._v(" "), _c('router-link', {
    staticClass: "resources",
    attrs: {
      "to": {
        name: 'Resources'
      }
    }
  }, [_vm._v("Resources")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "nav-item mob"
  }, [_c('search-module')], 1) : _vm._e(), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "nav-item mob subscribe"
  }, [_c('span', [_vm._v("Subscribe")]), _vm._v(" "), _c('subscribe-module')], 1) : _vm._e()])]), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "scrim",
    on: {
      "click": _vm.unexpand
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "https://longestshortesttime.supportingcast.fm/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', [_vm._v("Join the Club")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "https://the-longest-shortest-time.myshopify.com/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', [_vm._v("Shop")])])])
}]}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment"
  }, [_c('h4', [_vm._v(_vm._s(_vm.comment.author.name))]), _vm._v(" "), _c('p', {
    staticClass: "commentMeta"
  }, [_vm._v(_vm._s(_vm.commentDate))]), _c('p'), _c('div', {
    staticClass: "commentContent",
    domProps: {
      "innerHTML": _vm._s(_vm.comment.content)
    }
  }), _vm._v(" "), (_vm.replying) ? _c('comment-form', {
    attrs: {
      "postId": _vm.postId,
      "parentId": _vm.comment.id,
      "child": true
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.replying && _vm.comment.depth < 5) ? _c('button', {
    staticClass: "button button-underline",
    on: {
      "click": _vm.toggleReply
    }
  }, [_vm._v("Reply")]) : _vm._e(), _vm._v(" "), (_vm.children) ? _c('div', [(_vm.children.length) ? _c('child-comments', {
    attrs: {
      "comments": _vm.children,
      "childComments": _vm.childComments,
      "postId": _vm.postId
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content",
    class: !_vm.loading ? '' : 'loading'
  }, [(_vm.notFound) ? _c('not-found') : _vm._e(), _vm._v(" "), (_vm.currentPost && _vm.currentPost.publishStatus === 'publish') ? _c('div', [(_vm.currentPost.postType === 'episode') ? _c('episode', {
    attrs: {
      "episode": _vm.currentPost
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentPost.postType === 'extra') ? _c('extra', {
    attrs: {
      "extra": _vm.currentPost
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentPost.postType === 'page') ? _c('page', {
    attrs: {
      "page": _vm.currentPost
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content"
  }, [_c('section', {
    staticClass: "container"
  }, [_c('extra-filter'), _vm._v(" "), _c('div', {
    class: !_vm.loading ? '' : 'loading'
  }, [_vm._l((_vm.extras), function(extra, index) {
    return (_vm.extras && _vm.extras.length) ? _c('extra', {
      key: extra.slug,
      attrs: {
        "index": index,
        "extra": extra
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.extras || !_vm.extras.length) ? _c('div', [_c('h2', [_vm._v("No Results")]), _vm._v(" "), _c('p', [_vm._v("Please try again")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-waypoint', {
    on: {
      "waypoint-in": _vm.nextPage
    }
  }) : _vm._e()], 2)], 1), _vm._v(" "), (_vm.scrolled) ? _c('button', {
    staticClass: "sttButton button is-primary",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_vm._v("Top")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page) ? _c('main', {
    staticClass: "page-content"
  }, [_c('hero', {
    attrs: {
      "page": _vm.page
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "categories container"
  }, [_c('h2', [_vm._v("Categories")]), _vm._v(" "), _c('ul', _vm._l((_vm.page.resources), function(category) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm._f("toSlug")('#' + category.category)
      }
    }, [_vm._v(_vm._s(category.category))])])
  }))]), _vm._v(" "), _c('section', _vm._l((_vm.page.resources), function(category) {
    return _c('div', {
      staticClass: "resources-list container",
      attrs: {
        "id": _vm._f("toSlug")(category.category)
      }
    }, [_c('h3', [_vm._v(_vm._s(category.category))]), _vm._v(" "), _c('ul', _vm._l((category.resources), function(item) {
      return _c('li', [_c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        },
        domProps: {
          "innerHTML": _vm._s(item.link_text)
        }
      })])
    }))])
  }))], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [(_vm.hasHero) ? _c('hero', {
    attrs: {
      "page": _vm.page
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "postContent",
    style: ({
      background: 'transparent',
      width: '100%'
    })
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.page.policy_id) ? _c('div', {
    staticClass: "fullWidth"
  }, [(!_vm.hasHero) ? _c('h1', {
    staticClass: "pageTitle",
    domProps: {
      "innerHTML": _vm._s(_vm.page.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pageContent)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.page.policy_id) ? _c('div', {
    staticClass: "fullWidth"
  }, [(_vm.policy) ? _c('div', {
    attrs: {
      "id": "policy-embed"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.policy)
    }
  }) : _c('div', [_c('p', [_vm._v("\n            Please wait while the policy is loaded. If it does not load, please "), _c('a', {
    attrs: {
      "href": ("https://app.termageddon.com/api/policy/" + (_vm.page.policy_id) + "?h-align=left&no-title=true&table-style=accordion"),
      "target": "_blank",
      "rel": "nofollow noopener"
    }
  }, [_vm._v("click here")]), _vm._v(".\n          ")])])]) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('top-nav'), _vm._v(" "), _c('masthead'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('site-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content"
  }, [_c('section', {
    staticClass: "container"
  }, [_c('episode-filter'), _vm._v(" "), _c('div', {
    class: !_vm.loading ? '' : 'loading'
  }, [_vm._l((_vm.episodes), function(episode, index) {
    return (_vm.episodes && _vm.episodes.length) ? _c('episode', {
      key: episode.slug,
      attrs: {
        "index": index,
        "episode": episode
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.episodes || !_vm.episodes.length) ? _c('div', [_c('h2', [_vm._v("No Results")]), _vm._v(" "), _c('p', [_vm._v("Please try again")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-waypoint', {
    on: {
      "waypoint-in": _vm.nextPage
    }
  }) : _vm._e()], 2)], 1), _vm._v(" "), (_vm.scrolled) ? _c('button', {
    staticClass: "sttButton button is-primary",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_vm._v("Top")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "episodeFilter"
    }
  }, [_c('h4', [_vm._v("Filter By")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.toggleYearOff),
      expression: "toggleYearOff"
    }],
    staticClass: "filterSelector yearSelector",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "selectorValue",
    on: {
      "click": _vm.toggleYear
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$parent.year || 'Year') + "\n      "), _c('img', {
    class: _vm.yearToggled ? 'toggled' : '',
    attrs: {
      "src": __webpack_require__(81),
      "width": "18",
      "height": "10"
    }
  })]), _vm._v(" "), (_vm.yearToggled) ? _c('div', {
    staticClass: "selectorOptions"
  }, [_c('p', {
    attrs: {
      "data-value": ""
    },
    on: {
      "click": function($event) {
        _vm.selectYear($event)
      }
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "mdi:close"
    }
  }), _vm._v(" Clear Filter\n      ")], 1), _vm._v(" "), _c('ul', _vm._l((_vm.years), function(yr) {
    return _c('li', {
      attrs: {
        "data-value": yr
      },
      on: {
        "click": function($event) {
          _vm.selectYear($event)
        }
      }
    }, [_vm._v(_vm._s(yr))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.toggleTopicOff),
      expression: "toggleTopicOff"
    }],
    staticClass: "filterSelector topicSelector",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "selectorValue",
    on: {
      "click": _vm.toggleTopic
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$parent.thisTopic ? _vm.$parent.thisTopic.name : 'Topic') + "\n      "), _c('img', {
    class: _vm.topicToggled ? 'toggled' : '',
    attrs: {
      "src": __webpack_require__(81),
      "width": "18",
      "height": "10"
    }
  })]), _vm._v(" "), (_vm.topicToggled) ? _c('div', {
    staticClass: "selectorOptions"
  }, [_c('p', {
    attrs: {
      "data-value": ""
    },
    on: {
      "click": function($event) {
        _vm.selectTopic($event)
      }
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "mdi:close"
    }
  }), _vm._v(" Clear Filter")], 1), _vm._v(" "), _c('ul', _vm._l((_vm.topics), function(topic) {
    return _c('li', {
      attrs: {
        "data-value": topic.slug
      },
      on: {
        "click": function($event) {
          _vm.selectTopic($event)
        }
      }
    }, [_vm._v(_vm._s(topic.name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  })])
},staticRenderFns: []}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.tag) ? _c('h1', [_c('strong', [_vm._v("Tag:")]), _vm._v(" " + _vm._s(_vm.tag.name))]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "searchResults",
    class: !_vm.loading ? '' : 'loading'
  }, [_vm._l((_vm.results), function(result) {
    return _c('search-result', {
      key: result.slug,
      attrs: {
        "result": result
      }
    })
  }), _vm._v(" "), (!_vm.results || !_vm.results.length) ? _c('div', [_c('h2', [_vm._v("No Results")]), _vm._v(" "), _c('p', [_vm._v("Please try a search")])]) : _vm._e(), _vm._v(" "), (_vm.totalPages > 1) ? _c('pagination', {
    attrs: {
      "totalPages": _vm.totalPages
    }
  }) : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "page"
  }, [_c('hero', {
    attrs: {
      "extra": _vm.extra,
      "comments": _vm.extra.comments.length
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "postContent"
  }, [_c('div', {
    staticClass: "container",
    domProps: {
      "innerHTML": _vm._s(_vm.extraContent)
    }
  }), _vm._v(" "), (_vm.extra.tags) ? _c('div', {
    staticClass: "container tags"
  }, [_c('p', [_c('strong', [_vm._v("Tags:")]), _vm._v(" "), _vm._l((_vm.extra.tags), function(tag, index) {
    return _c('span', [_c('a', {
      attrs: {
        "href": '/tag/' + tag.slug
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(tag.name)
      }
    })]), _vm._v(" "), ((index + 1) < _vm.extra.tags.length) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "postContent commentsContent"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('comments', {
    attrs: {
      "comments": _vm.extra.comments,
      "postId": _vm.extra.id
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "hpcta"
    }
  }, [(_vm.siteInfo) ? _c('header', {
    staticClass: "circleHeader"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.siteInfo.homepageCTA.text)
    }
  }), _vm._v(" "), (_vm.siteInfo.homepageCTA.image) ? _c('img', {
    attrs: {
      "src": _vm.siteInfo.homepageCTA.image.sizes.medium,
      "alt": ""
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "result",
    class: _vm.result.postType
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    })
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.result.slug
        }
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.result.slug
        }
      }
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.result.title)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "meta"
  }, [(_vm.result.postType === 'extra') ? _c('span', [_vm._v("Extra •")]) : _vm._e(), _vm._v(" "), (_vm.result.number) ? _c('span', [_vm._v(_vm._s(_vm.episodeNumber) + " •")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formattedDate))]), _vm._v(" "), (_vm.resultTopics) ? _c('span', [_vm._v("• \n        "), _vm._l((_vm.resultTopics), function(topic, index) {
    return _c('span', [(_vm.result.postType === 'episode') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'Category',
          params: {
            topic: topic.slug
          }
        }
      },
      domProps: {
        "innerHTML": _vm._s(topic.name)
      }
    }) : _c('router-link', {
      attrs: {
        "to": {
          name: 'Extras',
          query: {
            topic: topic.slug
          }
        }
      },
      domProps: {
        "innerHTML": _vm._s(topic.name)
      }
    }), (index + 1 !== _vm.resultTopics.length) ? _c('span', [_vm._v(", ")]) : _vm._e()], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.result.excerpt)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "more-link",
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.result.slug
        }
      }
    }
  }, [_vm._v("More")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "childComments"
  }, _vm._l((_vm.sortedComments), function(comment, index) {
    return _c('comment', {
      key: index,
      attrs: {
        "comment": comment,
        "childComments": _vm.childComments,
        "postId": _vm.postId
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shopItems) ? _c('section', [_c('div', {
    staticClass: "shop container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "moduleItems"
  }, _vm._l((_vm.shopItems), function(item) {
    return _c('a', {
      attrs: {
        "target": "_blank",
        "href": item.link || 'https://www.podswag.com/collections/longest-shortest-time'
      }
    }, [_c('span', {
      staticClass: "img",
      style: ({
        backgroundImage: ("url(" + (_vm.featured(item.image)) + ")")
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "shopContent"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.price)
      }
    })])])
  }))])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circleHeader"
  }, [_c('h2', [_vm._v("Shop our store"), _c('br'), _vm._v("\n        and support the show!")])])
}]}

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.extras) ? _c('section', [_c('div', {
    staticClass: "extras container"
  }, _vm._l((_vm.extras), function(extra) {
    return _c('extra-module', {
      key: extra.slug,
      attrs: {
        "extra": extra
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "text-right container"
  }, [_c('router-link', {
    staticClass: "button button-underline",
    attrs: {
      "to": {
        name: 'Extras'
      }
    }
  }, [_vm._v("All Extras")])], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.success) ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.unfocus),
      expression: "unfocus"
    }],
    staticClass: "mod"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.focused),
      expression: "!focused"
    }],
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focus": _vm.focus,
      "click": _vm.focus
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.focused),
      expression: "focused"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "input",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, _vm.removeError],
      "focus": _vm.focus,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        if (!$event.shiftKey) { return null; }
        _vm.unfocus($event)
      }]
    }
  }), _vm._v(" "), _c('button', {
    ref: "button",
    staticClass: "button",
    on: {
      "click": _vm.submit,
      "focus": _vm.focus,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.unfocus($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(315),
      "width": "20",
      "height": "20"
    }
  })])]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]) : _c('div', {
    staticClass: "mod success"
  }, [_c('div', [_c('span', {
    staticClass: "placeholder",
    style: ({
      textAlign: 'left'
    })
  }, [_vm._v("Thank you"), _c('br'), _vm._v(" for subscribing!")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "placeholder"
  }, [_vm._v("\n        Enter Your Email"), _c('br'), _vm._v("\n        To Get The Newsletter\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "button"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(315),
      "width": "20",
      "height": "20"
    }
  })])
}]}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('header', {
    staticClass: "circleHeader",
    style: (_vm.success ? {
      marginBottom: '70px'
    } : '')
  }, [_c('h2', [_vm._v(_vm._s(_vm.contact.title))])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.content)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._l((_vm.logos), function(logo, index) {
    return _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentLogo === index),
        expression: "currentLogo === index"
      }],
      staticClass: "logoAnimation",
      attrs: {
        "width": "580",
        "height": "227",
        "src": logo
      }
    })
  }), _vm._v(" "), _c('img', {
    staticClass: "logoMobile",
    attrs: {
      "width": "180",
      "height": "43",
      "src": __webpack_require__(704)
    }
  }), _vm._v(" "), _c('span', [_vm._v("The Longest Shortest Time")])], 2)])
},staticRenderFns: []}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "pressItem"
  }, [_c('header', [(_vm.item.link) ? _c('a', {
    staticClass: "img",
    style: (_vm.imgStyle),
    attrs: {
      "href": _vm.item.link,
      "target": "_blank"
    }
  }) : _c('div', {
    staticClass: "img",
    style: (_vm.imgStyle)
  }), _vm._v(" "), _c('p', {
    staticClass: "meta"
  }, [_vm._v(_vm._s(_vm.formattedPubDate))]), _vm._v(" "), _c('h4', [(_vm.item.link) ? _c('a', {
    attrs: {
      "href": _vm.item.link,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.item.headline)
    }
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.headline)
    }
  })])]), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.excerpt)
    }
  }), _vm._v(" [...]\n    "), (_vm.item.link) ? _c('a', {
    staticClass: "more-link",
    attrs: {
      "href": _vm.item.link,
      "target": "_blank"
    }
  }, [_vm._v("More")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination"
  }, [(_vm.currentPage > 1) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.goToPage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("Prev")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagers"
  }, _vm._l((_vm.pagination), function(page) {
    return _c('div', {
      staticClass: "pager"
    }, [(page === _vm.currentPage) ? _c('span', {
      staticClass: "currentPage"
    }, [_vm._v(_vm._s(page))]) : (page === '...') ? _c('span', [_vm._v(_vm._s(page))]) : _c('a', {
      attrs: {
        "to": {
          name: 'Episodes',
          query: {
            page: page
          }
        }
      },
      on: {
        "click": function($event) {
          _vm.goToPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  })), _vm._v(" "), (_vm.currentPage < _vm.totalPages) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.goToPage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("Next")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "start-here container"
  }, [_c('h2', [_vm._v("Start here for...")]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Category',
        params: {
          topic: 'laugh'
        }
      }
    }
  }, [_c('span', [_vm._v("A Laugh")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Category',
        params: {
          topic: 'good-cry'
        }
      }
    }
  }, [_c('span', [_vm._v("A Good Cry")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Category',
        params: {
          topic: 'surprise'
        }
      }
    }
  }, [_c('span', [_vm._v("A Surprise")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Category',
        params: {
          topic: 'staff-faves'
        }
      }
    }
  }, [_c('span', [_vm._v("Staff Faves")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "episode"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    })
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.title)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "meta"
  }, [(_vm.episode.number) ? _c('span', [_vm._v(_vm._s(_vm.episodeNumber) + " •")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formattedDate))]), _vm._v(" "), (_vm.episodeTopics) ? _c('span', [_vm._v("• \n        "), _vm._l((_vm.episodeTopics), function(topic, index) {
    return _c('span', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Category',
          params: {
            topic: topic.slug
          }
        }
      },
      domProps: {
        "innerHTML": _vm._s(topic.name)
      }
    }), (index + 1 !== _vm.episodeTopics.length) ? _c('span', [_vm._v(", ")]) : _vm._e()], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.excerpt)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "more-link",
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }, [_vm._v("More")])], 1), _vm._v(" "), (_vm.index === 6) ? _c('v-waypoint', {
    on: {
      "waypoint": _vm.$parent.handleScroll
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player"
  }, [_c('div', {
    staticClass: "player-controls"
  }, [_c('button', [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "id": "replay_a"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "replay_b"
    }
  }, [_c('use', {
    attrs: {
      "overflow": "visible",
      "xlink:href": "#replay_a"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "clip-path": "url(#replay_b)",
      "d": "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
    }
  })])]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": ""
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": ""
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#000000",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M24 24H0V0h24v24z",
      "id": "forward_a"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "forward_b"
    }
  }, [_c('use', {
    attrs: {
      "overflow": "visible",
      "xlink:href": "#forward_a"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "clip-path": "url(#forward_b)",
      "d": "M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "scrub"
  }, [_c('input', {
    style: ({
      background: "linear-gradient( to right, #00cdbd 0%, #00cdbd 0%, #bfe0dd 0%, #bfe0dd 100% )"
    }),
    attrs: {
      "disabled": "",
      "type": "range",
      "value": "0",
      "min": "0",
      "max": "100"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "playerInfo"
  }, [_vm._v("Loading...")])])])
},staticRenderFns: []}

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.team), function(teamMember, index) {
    return _c('div', {
      key: index,
      staticClass: "teamMember"
    }, [_c('div', {
      staticClass: "img",
      style: ({
        backgroundImage: ("url(" + (_vm.photo(teamMember.photo)) + ")")
      })
    }), _vm._v(" "), _c('div', [_c('header', [_c('h3', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(teamMember.name)
      }
    })]), _vm._v(" "), _c('h4', {
      domProps: {
        "innerHTML": _vm._s(teamMember.role)
      }
    })]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(teamMember.bio)
      }
    })])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "circleHeader"
  }, [_c('h2', [_vm._v("The Team")])])
}]}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "kit"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.page) ? _c('div', {
    staticClass: "kit-lead",
    domProps: {
      "innerHTML": _vm._s(_vm.page.kit.content)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "newsletter-subscribe"
  }, [(!_vm.success) ? _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Your Email Address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.submit
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(705),
      "width": "43",
      "height": "43"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Send")])])]) : _c('div', [_c('h5', [_c('strong', [_vm._v("Success!")]), _c('br'), _vm._v("We'll be in touch!")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "circleHeader"
  }, [_c('div', [_c('h2', [_vm._v("Keep in Touch")])])])
}]}

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.error) ? _c('div', {
    staticClass: "notification is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.error.message)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.successMsg) ? _c('div', {
    staticClass: "notification is-success"
  }, [_vm._v(_vm._s(_vm.successMsg))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.content),
      expression: "comment.content"
    }],
    ref: "commentContent",
    staticClass: "textarea",
    attrs: {
      "placeholder": "Say something! Add your comment here...",
      "required": ""
    },
    domProps: {
      "value": (_vm.comment.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment.content = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.commenterSaved) ? _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.name),
      expression: "comment.name"
    }],
    ref: "commentName",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Your Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.comment.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.email),
      expression: "comment.email"
    }],
    ref: "commentEmail",
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": "Your Email Address",
      "required": ""
    },
    domProps: {
      "value": (_vm.comment.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment.email = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.commenterSaved) ? _c('div', {
    staticClass: "field"
  }, [_vm._v("\n    Commenting as: " + _vm._s(_vm.comment.name) + ". "), _c('button', {
    on: {
      "click": _vm.clearCommenterFromLocalStorage
    }
  }, [_vm._v("I'm not " + _vm._s(_vm.comment.name))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "has-text-right"
  }, [_c('button', {
    staticClass: "button button-underline",
    on: {
      "click": _vm.submitComment
    }
  }, [_vm._v("Submit")]), _vm._v(" "), (_vm.$parent.replying) ? _c('button', {
    staticClass: "button button-underline cancel",
    on: {
      "click": _vm.$parent.toggleReply
    }
  }, [_vm._v("Cancel")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.episode) ? _c('article', {
    staticClass: "page"
  }, [_c('hero', {
    attrs: {
      "episode": _vm.episode,
      "comments": _vm.episode.comments.length
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "postContent"
  }, [_c('div', {
    staticClass: "container",
    domProps: {
      "innerHTML": _vm._s(_vm.episodeContent)
    }
  }), _vm._v(" "), _c('footer', {
    staticClass: "episodeFooter container"
  }, [(_vm.episode.sponsors) ? _c('div', {
    staticClass: "episodeSponsors"
  }, [_c('h3', [_vm._v("Sponsors for this Episode")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.sponsors)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.episode.tags || _vm.topics) ? _c('div', {
    staticClass: "topicsTags"
  }, [(_vm.topics && _vm.topics.length) ? _c('div', [_c('h5', [_vm._v("Topics")]), _vm._v(" "), _c('p', _vm._l((_vm.topics), function(topic, index) {
    return _c('span', [_c('router-link', {
      attrs: {
        "to": '/category/' + topic.slug
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(topic.name)
      }
    })]), _vm._v(" "), ((index + 1) < _vm.topics.length) ? _c('span', {
      staticClass: "sep"
    }, [_vm._v(" • ")]) : _vm._e()], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.episode.tags && _vm.episode.tags.length) ? _c('div', [_c('h5', [_vm._v("Tags")]), _vm._v(" "), _c('p', _vm._l((_vm.episode.tags), function(tag, index) {
    return _c('span', [_c('router-link', {
      attrs: {
        "to": '/tag/' + tag.slug
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(tag.name)
      }
    })]), _vm._v(" "), ((index + 1) < _vm.episode.tags.length) ? _c('span', {
      staticClass: "sep"
    }, [_vm._v(" • ")]) : _vm._e()], 1)
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.episode.ctaQuestion || _vm.episode.ctaDescription) ? _c('div', {
    staticClass: "episodeCta"
  }, [(_vm.episode.ctaQuestion) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.ctaQuestion)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.episode.ctaDescription) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.ctaDescription)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.episode.transcript) ? _c('div', {
    staticClass: "transcript"
  }, [_c('h2', [_vm._v("Podcast Transcript")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.episodeTranscript)
    }
  }), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.transcriptExpanded = !_vm.transcriptExpanded
      }
    }
  }, [_vm._v(_vm._s(_vm.transcriptExpanded ? 'Show Less' : 'Show More'))])])]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "postContent commentsContent"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('comments', {
    attrs: {
      "comments": _vm.episode.comments,
      "postId": _vm.episode.id
    }
  })], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.extra) ? _c('article', {
    staticClass: "extra article"
  }, [_c('router-link', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    }),
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.extra.title)
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.extra.excerpt)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "more-link",
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  }, [_vm._v("More")])], 1), _vm._v(" "), _c('div', {
    staticClass: "readModule"
  }, [_c('router-link', {
    staticClass: "readButton",
    attrs: {
      "tag": "button",
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  }, [_c('span', [_vm._v("Read more")])])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content",
    class: !_vm.loading ? '' : 'loading'
  }, [(_vm.post) ? _c('div', [(_vm.post.postType === 'episode') ? _c('episode', {
    attrs: {
      "episode": _vm.post
    }
  }) : _vm._e(), _vm._v(" "), (_vm.post.postType === 'extra') ? _c('extra', {
    attrs: {
      "extra": _vm.post
    }
  }) : _vm._e(), _vm._v(" "), (_vm.post.postType === 'page') ? _c('page', {
    attrs: {
      "page": _vm.post
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(328);
module.exports = __webpack_require__(327);


/***/ })
]),[811]);


// WEBPACK FOOTER //
// static/js/app.f22b33a5141c547228fb.js